export interface OlefinRoute {
  id: string;
  name: string;
  description: string;
  source: string;
  feedstock: string[];
  products: string[];
  byproducts: string[];
  processSteps: string[];
  carbonEfficiency: string;
  status: 'commercial' | 'pilot' | 'research';
  temperature?: string;
  pressure?: string;
  oxygenCoalRatio?: string;
  advantages?: string[];
  challenges?: string[];
}

export const routesData: OlefinRoute[] = [
  {
    id: 'steam-cracking',
    name: '蒸汽裂解',
    description: '以石脑油、柴油等石油馏分为原料，在高温（750-900℃）下进行热裂解，通过急冷、压缩和分馏分离出乙烯',
    source: '石油路线',
    feedstock: ['石脑油', '柴油'],
    products: ['乙烯', '丙烯', '丁烯'],
    byproducts: ['甲烷', '乙烷', 'C5+(碳五及以上重组分)'],
    processSteps: [
      '原料预热',
      '高温裂解(750-900℃)',
      '急冷分离',
      '压缩分馏'
    ],
    carbonEfficiency: '50-60%',
    temperature: '750-900℃',
    status: 'commercial',
    advantages: ['技术成熟度高', '全球占比70%', '工艺稳定可靠'],
    challenges: ['能耗较高', '碳排放较大', '原料依赖石油']
  },
  {
    id: 'catalytic-cracking',
    name: '催化裂解',
    description: '使用重质石油馏分（如蜡油、渣油），在沸石分子筛催化剂作用下生成低碳烯烃',
    source: '石油路线',
    feedstock: ['蜡油', '渣油'],
    products: ['乙烯', '丙烯', '丁烯'],
    byproducts: ['C5+(碳五及以上重组分)', '焦炭'],
    processSteps: [
      '原料预处理',
      '催化裂解',
      '油剂分离',
      '产物分馏'
    ],
    carbonEfficiency: '60-70%',
    temperature: '500-700℃',
    status: 'commercial',
    advantages: ['丙烯收率高', '缩短加工链条', '原料灵活'],
    challenges: ['乙烯收率较低', '催化剂成本', '焦炭处理']
  },
  {
    id: 'ccr',
    name: '持续催化重整',
    description: '以石脑油为原料，在铂系催化剂作用下，通过脱氢、异构化和芳构化反应，生产高辛烷值汽油组分、芳烃及副产氢气',
    source: '石油路线',
    feedstock: ['石脑油'],
    products: ['重整汽油', '芳烃'],
    byproducts: ['氢气', '液化石油气'],
    processSteps: [
      '原料预处理',
      '催化重整反应',
      '催化剂连续再生',
      '产物分离提纯'
    ],
    carbonEfficiency: '85-90%',
    temperature: '490-540℃',
    status: 'commercial',
    advantages: ['高辛烷值汽油', '副产高纯氢气', '装置运行周期长'],
    challenges: ['催化剂价格昂贵', '能耗较高']
  },
  {
    id: 'hydrocracking',
    name: '加氢裂化',
    description: '在催化剂和高压氢气存在下，使重质油发生裂化反应，转化为轻质油（石脑油、航空煤油、柴油等）的工艺',
    source: '石油路线',
    feedstock: ['减压蜡油', '氢气'],
    products: ['石脑油', '航空煤油', '柴油'],
    byproducts: ['液化气', '尾油'],
    processSteps: [
      '原料预热加压',
      '加氢处理/裂化',
      '高压分离',
      '分馏提纯'
    ],
    carbonEfficiency: '95%以上',
    temperature: '350-450℃',
    status: 'commercial',
    advantages: ['产品收率高', '产品质量好', '原料适应性强'],
    challenges: ['设备投资大', '氢耗量大', '操作压力高']
  },
  {
    id: 'delayed-coking',
    name: '延迟焦化',
    description: '以减压渣油等重质油为原料，在约500℃高温下进行深度热裂化和缩合反应，生产汽油、柴油、蜡油及石油焦的热裂化工艺',
    source: '石油路线',
    feedstock: ['减压渣油', '常压渣油'],
    products: ['汽油', '柴油', '蜡油', '石油焦'],
    byproducts: ['焦化气体', '液化气'],
    processSteps: [
      '加热炉快速加热',
      '焦炭塔裂化缩合',
      '主分馏塔分馏',
      '水力除焦'
    ],
    carbonEfficiency: '95%以上',
    temperature: '490-510℃',
    status: 'commercial',
    advantages: ['原料适应性极强', '无催化剂参与', '加工费用低', '柴汽比高'],
    challenges: ['焦炭产率高', '液体产品性质差', '属限制类项目']
  },
  {
    id: 'coal-gasification',
    name: '煤气化炉制合成气',
    description: '原煤磨煤制浆（水煤浆）或制粉（干煤粉）后送入加压气流床气化炉，与氧气、水蒸气在高温高压下部分氧化，生成以一氧化碳(CO)和氢气(H₂)为主的合成气，经激冷洗涤、CO变换与低温甲醇洗净化，成为甲醇、合成氨、制氢等下游产品的原料气平台',
    source: '煤化工路线',
    feedstock: ['原煤', '氧气', '水蒸气'],
    products: ['合成气(CO+H₂)'],
    byproducts: ['灰渣/细渣', 'CO₂(二氧化碳)', '硫磺'],
    processSteps: [
      '原煤破碎磨煤(制浆/制粉)',
      '气化炉加压气化(1300-1500℃)',
      '激冷洗涤除渣除尘',
      '废热回收副产蒸汽',
      'CO变换(调整氢碳比)',
      '低温甲醇洗(脱硫脱碳)',
      '净化合成气送下游(甲醇/合成氨/氢)'
    ],
    carbonEfficiency: '80%左右(有效气)',
    temperature: '1300-1500℃(气化炉)',
    pressure: '4.0-6.5 MPa(加压气化)',
    oxygenCoalRatio: '480-550 Nm³ O₂/t干煤(水煤浆)',
    status: 'commercial',
    advantages: [
      '煤种适应性宽，可用劣质煤、高灰熔点煤',
      '气化压力高，单炉规模大，碳转化率98%以上',
      '是煤制烯烃/煤制天然气/煤制氢的共性源头平台',
      '炉渣与副产蒸汽可综合利用，降低综合能耗'
    ],
    challenges: [
      '氧煤比与炉温强耦合，操作窗口窄，需精准控氧',
      '氧气与高温高压设备带来安全风险',
      '对煤的灰熔点、成浆性(水煤浆)要求高',
      '配套空分装置投资大、能耗高'
    ]
  },
  {
    id: 'mto',
    name: '甲醇制烯烃(MTO)',
    description: '以煤或天然气为原料，先制成甲醇，再在分子筛催化剂作用下转化为乙烯、丙烯等低碳烯烃',
    source: '煤化工路线',
    feedstock: ['煤', '天然气'],
    products: ['乙烯', '丙烯'],
    byproducts: ['水', 'C4+(碳四及以上烃类)', 'CO₂(二氧化碳)'],
    processSteps: [
      '煤气化/天然气转化',
      '甲醇合成',
      'MTO反应',
      '烯烃分离'
    ],
    carbonEfficiency: '35-45%',
    temperature: '400-500℃',
    status: 'commercial',
    advantages: ['原料来源广泛', '不依赖石油', '中国资源禀赋匹配'],
    challenges: ['碳排放高', '水耗大', '投资成本高']
  },
  {
    id: 'ctg',
    name: '煤制天然气',
    description: '以煤为原料，通过气化、变换、净化和甲烷化等过程，生产代用天然气（SNG）',
    source: '煤化工路线',
    feedstock: ['煤'],
    products: ['天然气'],
    byproducts: ['焦油', '粗酚', '硫磺'],
    processSteps: [
      '煤气化',
      '变换反应',
      '低温甲醇洗',
      '甲烷化'
    ],
    carbonEfficiency: '55-60%',
    temperature: '250-700℃',
    status: 'commercial',
    advantages: ['解决天然气缺口', '劣质煤利用', '技术成熟'],
    challenges: ['碳排放高', '水资源消耗大', '投资成本高']
  },
  {
    id: 'mtp',
    name: '甲醇制丙烯(MTP)',
    description: '以甲醇为原料，通过分子筛催化剂作用，选择性生产丙烯',
    source: '煤化工路线',
    feedstock: ['煤', '天然气'],
    products: ['丙烯'],
    byproducts: ['汽油', 'LPG(液化石油气)', '水'],
    processSteps: [
      '煤气化',
      '甲醇合成',
      'MTP反应',
      '丙烯分离'
    ],
    carbonEfficiency: '40-50%',
    temperature: '450-500℃',
    status: 'commercial',
    advantages: ['丙烯选择性高', '原料灵活', '工艺相对简单'],
    challenges: ['碳排放高', '副产物处理', '催化剂寿命']
  },
  {
    id: 'gto',
    name: '天然气制烯烃(GTO)',
    description: '以天然气为原料，通过蒸汽转化制合成气，再合成甲醇，最后转化为烯烃',
    source: '天然气路线',
    feedstock: ['天然气'],
    products: ['乙烯', '丙烯'],
    byproducts: ['水', 'CO2'],
    processSteps: [
      '天然气蒸汽转化',
      '甲醇合成',
      'MTO(甲醇制烯烃)反应',
      '烯烃分离'
    ],
    carbonEfficiency: '55-65%',
    temperature: '800-900℃',
    status: 'commercial',
    advantages: ['碳排放低于煤制', '工艺成熟', '中东地区优势明显'],
    challenges: ['天然气价格波动', '远离消费市场', '投资成本高']
  },
  {
    id: 'gtl',
    name: '天然气制油(GTL)',
    description: '以天然气为原料，通过费托合成工艺转化为清洁液体燃料',
    source: '天然气路线',
    feedstock: ['天然气'],
    products: ['柴油', '石脑油', '航空煤油'],
    byproducts: ['LPG(液化石油气)', '润滑油基础油'],
    processSteps: [
      '天然气蒸汽转化',
      '合成气制备',
      '费托合成',
      '产品加氢提质'
    ],
    carbonEfficiency: '60-70%',
    temperature: '200-350℃',
    status: 'commercial',
    advantages: ['超清洁燃料', '硫含量极低', '产品附加值高'],
    challenges: ['投资巨大', '天然气价格敏感', '技术门槛高']
  },
  {
    id: 'bto',
    name: '生物质制烯烃',
    description: '以生物质（如秸秆、甘蔗渣）为原料，通过发酵或气化路线生产烯烃',
    source: '其他路线',
    feedstock: ['生物质', '秸秆', '甘蔗渣'],
    products: ['乙烯', '丙烯'],
    byproducts: ['CO2', '水', '有机肥'],
    processSteps: [
      '生物质预处理',
      '发酵/气化',
      '乙醇脱水/合成',
      '烯烃分离'
    ],
    carbonEfficiency: '30-40%',
    temperature: '300-500℃',
    status: 'pilot',
    advantages: ['碳中和潜力', '可再生资源', '环境友好'],
    challenges: ['原料收集成本高', '技术尚不成熟', '经济性待提升']
  },
  {
    id: 'pdh',
    name: '丙烷脱氢(PDH)',
    description: '以丙烷为原料，在催化剂作用下脱氢生成丙烯',
    source: '其他路线',
    feedstock: ['丙烷'],
    products: ['丙烯'],
    byproducts: ['氢气'],
    processSteps: [
      '丙烷预热',
      '催化脱氢',
      '产物分离',
      '丙烯提纯'
    ],
    carbonEfficiency: '80-85%',
    temperature: '550-650℃',
    status: 'commercial',
    advantages: ['丙烯收率高', '副产氢气', '工艺简单'],
    challenges: ['丙烷原料依赖进口', '催化剂结焦', '能耗较高']
  },
  {
    id: 'oco',
    name: '氧化偶联制烯烃(OCO)',
    description: '以甲烷为原料，通过氧化偶联反应直接转化为C2+烯烃',
    source: '其他路线',
    feedstock: ['甲烷', '氧气'],
    products: ['乙烯', '乙烷'],
    byproducts: ['水', 'CO', 'CO2'],
    processSteps: [
      '甲烷预热',
      '氧化偶联反应',
      '急冷分离',
      '产物提纯'
    ],
    carbonEfficiency: '20-30%',
    temperature: '700-900℃',
    status: 'research',
    advantages: ['原料廉价', '一步转化', '潜力巨大'],
    challenges: ['转化率低', '选择性差', '催化剂稳定性']
  }
];

export const routeCategories = [
  { id: 'petroleum', label: '石油路线', source: '石油路线' },
  { id: 'coal', label: '煤化工路线', source: '煤化工路线' },
  { id: 'gas', label: '天然气路线', source: '天然气路线' },
  { id: 'other', label: '其他路线', source: '其他路线' },
];

export interface IndustrySubItem {
  id: string;
  name: string;
}

export interface Industry {
  id: string;
  name: string;
  description: string;
  color: string;
  subItems?: IndustrySubItem[];
}

export const industries: Industry[] = [
  {
    id: 'petroleum',
    name: '石油工业',
    description: '石油裂解、催化裂化、加氢裂化等',
    color: '#2e7d32',
    subItems: [
      { id: 'cracking', name: '裂解工艺' },
      { id: 'reforming', name: '重整工艺' },
      { id: 'hydrogenation', name: '加氢工艺' },
    ],
  },
  {
    id: 'plastic',
    name: '塑料制备',
    description: 'HDPE、LDPE、UHMWPE、PP等制备路线',
    color: '#2e7d32',
  },
  {
    id: 'chemical',
    name: '化学工业',
    description: '基础化工、精细化工、新材料等',
    color: '#2e7d32',
  },
  {
    id: 'air',
    name: '空气化工',
    description: '氮气、氧气等制备路线',
    color:'#2e7d32',
  },
  {
    id: 'pulp&paper',
    name: '制浆造纸',
    description: '展示制浆、造纸等工艺路线',
    color: '#2e7d32',
  },
 {
    id: 'mining',
    name: '冶金工业',
    description: '铁矿、铜矿、镍矿等冶炼工艺',
    color: '#2e7d32',
  },
  {
    id: 'biological',
    name: '生物医药',
    description: '生物制药、生物发酵、生物材料等',
    color: '#2e7d32',
  },
  {
    id: 'food',
    name: '食品发酵',
    description: '食品发酵、酒、乳酪等',
    color: '#2e7d32',
  },

];

export interface FoodRoute {
  id: string;
  name: string;
  description: string;
  category: string;
  feedstock: string[];
  products: string[];
  byproducts: string[];
  processSteps: string[];
  fermentationType: string;
  productionCycle: string;
  status: 'commercial' | 'traditional' | 'modern';
  temperature?: string;
  advantages?: string[];
  challenges?: string[];
  keyMicroorganisms?: string[];
}

export const foodRoutesData: FoodRoute[] = [
  {
    id: 'soy-sauce-high-salt',
    name: '高盐稀态发酵酱油',
    description: '以大豆和小麦为原料，采用高盐（17-18%）稀醪液态发酵，低温长周期（3-6个月），酱香浓郁、口感醇厚',
    category: '酱油制备',
    feedstock: ['大豆', '小麦', '盐水(17-18%)'],
    products: ['酱油'],
    byproducts: ['酱渣', '氨基酸液'],
    processSteps: [
      '大豆筛选泡豆',
      '高压蒸煮冷却',
      '小麦焙炒粉碎',
      '混合接种米曲霉',
      '制曲(48h)',
      '加盐水入罐发酵',
      '淋油搅拌控温',
      '压榨取油配制',
      '巴氏杀菌成品'
    ],
    fermentationType: '高盐稀态发酵',
    productionCycle: '3-6个月',
    temperature: '≤30℃',
    status: 'commercial',
    keyMicroorganisms: ['米曲霉', '耐盐酵母', '乳酸菌'],
    advantages: ['酱香浓郁', '口感醇厚', '风味复杂', '品质优良'],
    challenges: ['发酵周期长', '成本较高', '盐浓度控制难']
  },
  {
    id: 'soy-sauce-low-salt',
    name: '低盐固态发酵酱油',
    description: '以脱脂大豆和麸皮为原料，采用低盐（6-8%）固态发酵，高温短周期（15-30天），生产效率高',
    category: '酱油制备',
    feedstock: ['脱脂大豆', '麸皮', '盐水(6-8%)'],
    products: ['酱油'],
    byproducts: ['酱渣'],
    processSteps: [
      '脱脂大豆蒸煮',
      '麸皮混合',
      '接种米曲霉',
      '制曲',
      '拌盐水入池',
      '前期水解(42-45℃)',
      '后期发酵(30-32℃)',
      '浸出淋油',
      '配制杀菌成品'
    ],
    fermentationType: '低盐固态发酵',
    productionCycle: '15-30天',
    temperature: '42-45℃(前期)',
    status: 'commercial',
    keyMicroorganisms: ['米曲霉', '耐盐酵母', '乳酸菌'],
    advantages: ['生产周期短', '成本低', '效率高'],
    challenges: ['风味较淡', '香气不足', '略带焦苦']
  },
  {
    id: 'beer-lager',
    name: '拉格啤酒',
    description: '下面发酵啤酒，低温（8-13℃）长周期发酵，口感清爽、酒体轻盈，全球主流啤酒类型',
    category: '啤酒制备',
    feedstock: ['麦芽', '啤酒花', '水', '酵母'],
    products: ['拉格啤酒'],
    byproducts: ['酒糟', 'CO₂', '酵母泥'],
    processSteps: [
      '麦芽粉碎',
      '糖化(蛋白质休止+糖化休止)',
      '麦汁过滤',
      '煮沸加酒花',
      '回旋沉淀',
      '冷却充氧',
      '发酵(8-13℃)',
      '贮酒后熟(0℃)',
      '过滤杀菌灌装'
    ],
    fermentationType: '下面发酵',
    productionCycle: '5-10天+1-2月后熟',
    temperature: '8-13℃',
    status: 'commercial',
    keyMicroorganisms: ['啤酒酵母(下面发酵型)'],
    advantages: ['口感清爽', '酒体轻盈', '适合大规模生产'],
    challenges: ['发酵周期长', '温控要求高', '易氧化老化']
  },
  {
    id: 'beer-ale',
    name: '艾尔啤酒',
    description: '上面发酵啤酒，较高温度（15-24℃）短周期发酵，风味复杂、果香浓郁，精酿啤酒主流类型',
    category: '啤酒制备',
    feedstock: ['麦芽', '啤酒花', '水', '酵母'],
    products: ['艾尔啤酒'],
    byproducts: ['酒糟', 'CO₂', '酵母泥'],
    processSteps: [
      '麦芽粉碎',
      '糖化',
      '麦汁过滤',
      '煮沸加酒花',
      '冷却',
      '发酵(15-24℃)',
      '后熟',
      '过滤灌装'
    ],
    fermentationType: '上面发酵',
    productionCycle: '3-7天+短期后熟',
    temperature: '15-24℃',
    status: 'commercial',
    keyMicroorganisms: ['啤酒酵母(上面发酵型)'],
    advantages: ['风味复杂', '果香浓郁', '发酵周期短'],
    challenges: ['易染杂菌', '温控要求高', '保质期较短']
  },
  {
    id: 'baijiu-maotai',
    name: '酱香型白酒（12987工艺）',
    description: '茅台镇传统工艺，一年生产周期、两次投料、九次蒸煮、八次发酵、七次取酒，酱香突出、幽雅细腻',
    category: '白酒制备',
    feedstock: ['高粱', '小麦(制曲)', '水'],
    products: ['酱香型白酒'],
    byproducts: ['酒糟', '黄水'],
    processSteps: [
      '端午制曲(高温大曲)',
      '重阳下沙(第1次投料)',
      '糙沙(第2次投料)',
      '1-3轮取酒',
      '4-5轮大回酒(最佳)',
      '6轮小回酒',
      '7轮追糟酒',
      '分型定级',
      '陶坛窖藏3-5年',
      '勾调再贮存'
    ],
    fermentationType: '固态发酵+堆积发酵',
    productionCycle: '1年生产+3-5年窖藏',
    temperature: '60-70℃(制曲)',
    status: 'traditional',
    keyMicroorganisms: ['高温大曲多菌系', '芽孢杆菌', '酵母菌'],
    advantages: ['酱香突出', '幽雅细腻', '回味悠长', '空杯留香'],
    challenges: ['工艺复杂', '周期极长', '成本高昂', '堆积发酵不可省']
  },
  {
    id: 'baijiu-luzhou',
    name: '浓香型白酒',
    description: '泥窖发酵，续渣法工艺，万年糟传承，窖香浓郁、绵甜甘冽，中国白酒主流香型',
    category: '白酒制备',
    feedstock: ['高粱', '小麦(制曲)', '水', '母糟(万年糟)'],
    products: ['浓香型白酒'],
    byproducts: ['酒糟', '黄水'],
    processSteps: [
      '中高温大曲制备',
      '高粱粉碎配料',
      '混蒸续渣',
      '出甑摊凉',
      '加曲粉',
      '入泥窖发酵(60-70天)',
      '出窖蒸馏',
      '量质摘酒',
      '分级贮存勾调'
    ],
    fermentationType: '泥窖固态发酵',
    productionCycle: '60-70天/轮+1-3年窖藏',
    temperature: '55-60℃(制曲)',
    status: 'traditional',
    keyMicroorganisms: ['中高温大曲多菌系', '己酸菌', '丁酸菌', '酵母菌'],
    advantages: ['窖香浓郁', '绵甜甘冽', '周期相对较短', '工艺成熟'],
    challenges: ['窖池依赖性强', '老窖稀缺', '窖泥养护复杂']
  },

  {
    id: 'huangjiu-tanfan',
    name: '摊饭法黄酒',
    description: '传统高品质黄酒主流工艺，浸米保留浆水、摊冷落缸、开耙发酵，鲜灵柔和、甘润醇厚',
    category: '黄酒制备',
    feedstock: ['糯米', '麦曲', '酒药', '水', '浆水'],
    products: ['黄酒'],
    byproducts: ['酒糟'],
    processSteps: [
      '糯米过筛浸渍(2-3天)',
      '保留浆水',
      '蒸煮摊冷',
      '加清水浆水麦曲酒母',
      '落缸前发酵',
      '开耙(核心工艺)',
      '灌坛后酵(70-80天)',
      '压榨澄清',
      '煎酒灭菌',
      '陈酿(3年以上)'
    ],
    fermentationType: '边糖化边发酵(复式发酵)',
    productionCycle: '80-90天+3年陈酿',
    temperature: '自然温度',
    status: 'traditional',
    keyMicroorganisms: ['麦曲霉菌', '酒药酵母', '乳酸菌'],
    advantages: ['鲜灵柔和', '甘润醇厚', '品质最优', '传统工艺精髓'],
    challenges: ['开耙技术要求极高', '发酵难控制', '周期长', '依赖老师傅经验']
  },
  {
    id: 'wine-red',
    name: '红葡萄酒',
    description: '带皮发酵，浸渍提取果皮中花色苷、单宁和香气物质，颜色深、单宁强、结构感明显',
    category: '葡萄酒制备',
    feedstock: ['葡萄', 'SO₂', '酵母'],
    products: ['红葡萄酒'],
    byproducts: ['葡萄皮渣', '酒泥', 'CO₂'],
    processSteps: [
      '葡萄采摘分选',
      '除梗破碎',
      '加SO₂',
      '冷浸渍(可选)',
      '酒精发酵(带皮24-28℃)',
      '浸皮循环压帽',
      '压榨分离皮渣',
      '苹果酸-乳酸发酵(可选)',
      '橡木桶/不锈钢罐陈酿',
      '换桶澄清',
      '下胶过滤装瓶'
    ],
    fermentationType: '带皮酒精发酵+苹果酸乳酸发酵(MLF)',
    productionCycle: '8-10天发酵+数月-数年陈酿',
    temperature: '24-28℃(发酵), 12-15℃(陈酿)',
    status: 'commercial',
    keyMicroorganisms: ['酿酒酵母', '乳酸菌'],
    advantages: ['颜色深邃', '单宁丰富', '结构感强', '陈年潜力大'],
    challenges: ['葡萄品质决定上限', '浸渍管理复杂', '氧化控制严格']
  },
  {
    id: 'wine-white',
    name: '白葡萄酒',
    description: '皮汁分离后纯果汁发酵，低温保果香，清爽细腻、果香突出',
    category: '葡萄酒制备',
    feedstock: ['葡萄', 'SO₂', '酵母'],
    products: ['白葡萄酒'],
    byproducts: ['葡萄皮渣', '酒泥', 'CO₂'],
    processSteps: [
      '葡萄采摘分选',
      '除梗轻微破碎',
      '压榨取汁',
      '加SO₂',
      '低温静置澄清',
      '分离清汁',
      '酒精发酵(14-18℃)',
      '酒泥陈酿(可选)',
      '换桶澄清',
      '下胶过滤装瓶'
    ],
    fermentationType: '低温酒精发酵',
    productionCycle: '2-3周发酵+数月陈酿',
    temperature: '14-18℃(发酵)',
    status: 'commercial',
    keyMicroorganisms: ['酿酒酵母'],
    advantages: ['果香突出', '清爽细腻', '发酵周期短', '适合年轻时饮用'],
    challenges: ['葡萄品质要求高', '低温控制', '氧化敏感', '品种果香依赖']
  },
  {
    id: 'vinegar-shanxi',
    name: '老陈醋',
    description: '蒸酵熏淋陈五大工序，夏伏晒冬捞冰，传统工艺400天以上，熏香浓郁、酸味醇厚',
    category: '酿造陈醋',
    feedstock: ['高粱', '大曲(大麦+豌豆)', '麸皮', '谷糠', '稻壳', '盐'],
    products: ['老陈醋'],
    byproducts: ['醋糟'],
    processSteps: [
      '高粱磨碎润料',
      '蒸料冷却',
      '加大曲酒精发酵(液态15天)',
      '拌麸皮谷糠稻壳',
      '醋酸发酵(固态9-10天)',
      '加盐终止',
      '醋醅分两半',
      '一半熏醅(5天85℃)',
      '一半直接浸泡',
      '淋醋(熏醅+生醅套淋)',
      '陈酿(夏伏晒冬捞冰1年以上)',
      '过滤灭菌成品'
    ],
    fermentationType: '液态酒精发酵+固态醋酸发酵',
    productionCycle: '约400天以上',
    temperature: '25-26℃(酒精发酵), 85℃(熏醅)',
    status: 'traditional',
    keyMicroorganisms: ['大曲多菌系', '酵母菌', '醋酸菌', '红曲菌'],
    advantages: ['熏香浓郁', '酸味醇厚', '酯化陈香', '传统工艺精髓'],
    challenges: ['周期极长', '翻醅劳动强度大', '熏醅温度控制', '夏伏晒冬捞冰不可替代']
  },

    {
    id: 'cheese-natural',
    name: '天然干酪',
    description: '以牛乳为原料，凝乳酶作用形成凝乳，经切割、排乳清、压榨、盐渍、成熟制成，10斤牛奶≈1斤奶酪',
    category: '乳酪制备',
    feedstock: ['牛乳', '凝乳酶', '发酵剂', '盐'],
    products: ['天然干酪'],
    byproducts: ['乳清', '乳清蛋白'],
    processSteps: [
      '原料乳验收',
      '标准化',
      '杀菌冷却',
      '添加发酵剂预酸化',
      '加CaCl₂调整酸度',
      '加凝乳酶凝乳',
      '切割凝块',
      '搅拌升温排乳清',
      '成型压榨',
      '盐渍',
      '成熟(4-6月)',
      '上色挂蜡包装'
    ],
    fermentationType: '凝乳酶凝固+乳酸菌发酵',
    productionCycle: '1天+4-6月成熟',
    temperature: '30-32℃(凝乳), 13-15℃(成熟)',
    status: 'commercial',
    keyMicroorganisms: ['乳酸菌', '凝乳酶'],
    advantages: ['营养丰富', '风味独特', '保质期长', '牛奶精华浓缩'],
    challenges: ['抗生素检测严格', '凝乳酶效价控制', '成熟环境要求高']
  },
];

export const foodCategories = [
  { id: 'soy-sauce', label: '酱油制备', category: '酱油制备' },
  { id: 'beer', label: '啤酒制备', category: '啤酒制备' },
  { id: 'baijiu', label: '白酒制备', category: '白酒制备' },
  { id: 'huangjiu', label: '黄酒制备', category: '黄酒制备' },
  { id: 'wine', label: '葡萄酒制备', category: '葡萄酒制备' },
  { id: 'vinegar', label: '酿造陈醋', category: '酿造陈醋' },
 { id: 'cheese', label: '乳酪制备', category: '乳酪制备' },
];

export interface MiningRoute {
  id: string;
  name: string;
  description: string;
  category: string;
  feedstock: string[];
  products: string[];
  byproducts: string[];
  processSteps: string[];
  status: 'commercial' | 'traditional' | 'modern';
  temperature?: string;
  advantages?: string[];
  challenges?: string[];
  keyParameters?: string[];
}

export const miningRoutesData: MiningRoute[] = [
  {
    id: 'iron-ore',
    name: '铁矿冶炼',
    description: '从铁矿石到钢材的全流程：选矿→烧结/球团→高炉炼铁→转炉炼钢→连铸轧钢',
    category: '铁矿',
    feedstock: ['铁矿石(全铁TFe 20-40%)', '焦炭', '石灰石'],
    products: ['钢材', '生铁'],
    byproducts: ['炉渣', '煤气', '炉尘'],
    processSteps: [
      '露天/地下开采',
      '破碎筛分',
      '磨矿选别',
      '磁选/浮选',
      '脱水干燥',
      '烧结/球团制备',
      '高炉炼铁(1500-1600℃)',
      '转炉炼钢',
      '连铸',
      '轧钢成品'
    ],
    status: 'commercial',
    temperature: '1500-1600℃',
    advantages: ['技术成熟', '规模大', '成本低', '产量高'],
    challenges: ['能耗高', '碳排放大', '贫矿比例高', '环保压力大'],
    keyParameters: ['高炉利用系数2.0-2.5 t/(m³·天)', '入炉焦比337-400 kg/t', '铁精矿品位≥65%']
  },
  {
    id: 'copper-ore',
    name: '铜矿冶炼',
    description: '火法冶炼为主：浮选精矿→闪速熔炼→吹炼→电解精炼→阴极铜',
    category: '铜矿',
    feedstock: ['铜矿石(Cu 0.3-2%)', '熔剂', '氧气'],
    products: ['阴极铜(≥99.99%)'],
    byproducts: ['硫酸', '炉渣', '阳极泥'],
    processSteps: [
      '露天开采',
      '破碎磨矿',
      '浮选选别',
      '铜精矿(Cu 20-30%)',
      '闪速熔炼(1300-1450℃)',
      '吹炼制粗铜',
      '火法精炼',
      '电解精炼',
      '阴极铜成品'
    ],
    status: 'commercial',
    temperature: '1300-1450℃',
    advantages: ['回收率高(≥95%)', '硫捕集率≥99%', '产品质量高'],
    challenges: ['品位下降', '环保要求高', '能耗较高'],
    keyParameters: ['铜精矿品位20-30%', '综合能耗≤180 kg标煤/t', '电解电流密度200-350 A/m²']
  },
  {
    id: 'nickel-ore',
    name: '镍矿冶炼',
    description: '硫化镍矿浮选→火法冶炼；红土镍矿回转窑电炉(RKEF)法→镍铁或高压酸浸(HPAL)→硫酸镍',
    category: '镍矿',
    feedstock: ['硫化镍矿/红土镍矿', '熔剂', '硫酸'],
    products: ['电镍', '镍铁', '硫酸镍'],
    byproducts: ['铜', '钴', '铂族金属'],
    processSteps: [
      '露天/地下开采',
      '破碎磨矿',
      '浮选(硫化矿)',
      '造锍熔炼',
      '转炉吹炼',
      '高镍锍',
      '电解精炼',
      '电镍成品'
    ],
    status: 'commercial',
    temperature: '1200-1600℃',
    advantages: ['伴生元素多', '综合利用价值高', '工艺成熟'],
    challenges: ['红土矿难选', '能耗高', '环保压力大'],
    keyParameters: ['硫化镍精矿Ni 6-12%', '高压酸浸(HPAL)温度245-270℃', '回转窑电炉(RKEF)镍铁Ni+Co 10-30%']
  },
  {
    id: 'aluminum-ore',
    name: '铝矿冶炼',
    description: '拜耳法生产氧化铝→霍尔-埃鲁电解法生产铝',
    category: '铝矿',
    feedstock: ['铝土矿(Al₂O₃ 45-75%)', '氢氧化钠', '冰晶石'],
    products: ['铝锭(≥99.5%)'],
    byproducts: ['赤泥', 'CO₂'],
    processSteps: [
      '露天开采',
      '破碎磨矿',
      '拜耳法溶出',
      '赤泥分离',
      '种分分解',
      '氢氧化铝',
      '焙烧(1000-1300℃)',
      '氧化铝',
      '电解(950-970℃)',
      '铝锭成品'
    ],
    status: 'commercial',
    temperature: '950-970℃(电解)',
    advantages: ['工艺成熟', '产品质量高', '应用广泛'],
    challenges: ['能耗极高', '赤泥处理难', '碳排放大'],
    keyParameters: ['铝硅比(A/S) 4-7', '吨铝直流电耗12600-13500 kWh', '电流效率>94.5%']
  },
  {
    id: 'cobalt-ore',
    name: '钴矿冶炼',
    description: '铜钴伴生矿浮选→酸浸→萃取→电积→电解钴',
    category: '钴矿',
    feedstock: ['铜钴矿(Co 0.1-1.5%)', '硫酸', '萃取剂'],
    products: ['电解钴(≥99.95%)'],
    byproducts: ['阴极铜', '硫酸'],
    processSteps: [
      '露天开采',
      '破碎磨矿',
      '浮选选别',
      '硫酸化焙烧',
      '酸浸出',
      '净化除杂',
      '萃取分离',
      '电积',
      '电解钴成品'
    ],
    status: 'commercial',
    temperature: '580-620℃(焙烧)',
    advantages: ['伴生资源丰富', '新能源需求大', '回收率≥95%'],
    challenges: ['品位低', '伴生复杂', '环保要求高'],
    keyParameters: ['钴精矿Co≥0.2%', '高压酸浸温度190℃', '全流程回收率≥95%']
  },
  {
    id: 'gold-ore',
    name: '金矿冶炼',
    description: '浮选→氰化浸出→炭吸附→电积→熔炼→电解精炼',
    category: '金矿',
    feedstock: ['金矿石(1-15 g/t)', '氰化钠', '活性炭'],
    products: ['金锭(≥99.99%)'],
    byproducts: ['银', '铜', '硫'],
    processSteps: [
      '露天/地下开采',
      '破碎磨矿',
      '重选预富集',
      '浮选选别',
      '氰化浸出',
      '炭浆吸附',
      '解吸电积',
      '金泥熔炼',
      '电解精炼',
      '金锭成品'
    ],
    status: 'commercial',
    temperature: '1060-1200℃(熔炼)',
    advantages: ['价值高', '回收率80-95%', '工艺成熟'],
    challenges: ['品位下降', '氰化物毒性', '环保压力大'],
    keyParameters: ['原矿品位1-15 g/t(克/吨)', '精矿品位50-200 g/t', '氰化钠(NaCN)浓度300-600mg/L']
  },
  {
    id: 'silver-ore',
    name: '银矿冶炼',
    description: '浮选→火法熔炼→帕克斯法/电解精炼→银锭',
    category: '银矿',
    feedstock: ['银矿石(5-120 g/t)', '熔剂', '锌粉'],
    products: ['银锭(99.99%)'],
    byproducts: ['金', '铅', '铜'],
    processSteps: [
      '地下开采',
      '破碎磨矿',
      '浮选选别',
      '精矿熔炼(~1200℃)',
      '多尔合金',
      '帕克斯法',
      '蒸馏去锌',
      '氧化精炼',
      '电解精炼',
      '银锭成品'
    ],
    status: 'commercial',
    temperature: '~1200℃',
    advantages: ['伴生资源丰富', '回收率>90%', '工艺成熟'],
    challenges: ['独立矿少', '伴生依赖性强', '品位波动大'],
    keyParameters: ['工业品位100-120 g/t', '电解电流密度250-300 A/m²', '综合回收率99.2%']
  }
];

export const miningCategories = [
  { id: 'iron', label: '铁矿', category: '铁矿' },
  { id: 'copper', label: '铜矿', category: '铜矿' },
  { id: 'nickel', label: '镍矿', category: '镍矿' },
  { id: 'aluminum', label: '铝矿', category: '铝矿' },
  { id: 'cobalt', label: '钴矿', category: '钴矿' },
  { id: 'gold', label: '金矿', category: '金矿' },
  { id: 'silver', label: '银矿', category: '银矿' },
];

export interface PulpPaperRoute {
  id: string;
  name: string;
  description: string;
  category: string;
  feedstock: string[];
  products: string[];
  byproducts: string[];
  processSteps: string[];
  status: 'commercial' | 'traditional' | 'modern';
  temperature?: string;
  advantages?: string[];
  challenges?: string[];
  keyParameters?: string[];
}

export const pulpPaperRoutesData: PulpPaperRoute[] = [
  {
    id: 'mechanical-pulp',
    name: '机械浆',
    description: '利用机械摩擦使纤维分离，得率~95%，成本低但纤维损伤大',
    category: '制浆工艺',
    feedstock: ['云杉', '冷杉', '杨木等木段/木片'],
    products: ['机械浆'],
    byproducts: ['少量木屑'],
    processSteps: [
      '原料备料',
      '木段/木片预处理',
      '磨石磨木/盘磨',
      '磨浆(机械摩擦)',
      '筛选净化',
      '漂白(可选)',
      '成品浆'
    ],
    status: 'commercial',
    advantages: ['得率高(~95%)', '成本低', '不消耗化学药剂', '生产效率高'],
    challenges: ['纤维损伤大', '强度较低', '含木素高易返黄', '能耗高'],
    keyParameters: ['得率~95%', '白度~60%', '热磨机械浆(TMP)蒸汽预热温度<木素缩合温度', 'RTS技术优化(磨浆速度R/温度T/停留时间S)']
  },
  {
    id: 'chemical-pulp',
    name: '化学浆',
    description: '硫酸盐法为主，使用NaOH+Na₂S蒸煮，得率45-55%，纤维强度高',
    category: '制浆工艺',
    feedstock: ['木片', '氢氧化钠', '硫化钠'],
    products: ['化学浆', '碱回收白液'],
    byproducts: ['黑液', '白泥', '石灰'],
    processSteps: [
      '木片备料',
      '蒸煮(160-170℃)',
      '洗涤',
      '筛选',
      '漂白',
      '成品浆',
      '黑液蒸发',
      '燃烧回收',
      '绿液苛化',
      '白液回用'
    ],
    status: 'commercial',
    temperature: '160-170℃',
    advantages: ['纤维强度高', '浆白度高', '原料适应广', '碱回收成熟'],
    challenges: ['得率低', '化学品消耗大', '有臭气(总还原硫TRS)', '黑液需处理'],
    keyParameters: ['蒸煮温度160-170℃', '用碱量15-24%', '硫化度22-35%', '细浆得率45-55%']
  },
  {
    id: 'chemimechanical-pulp',
    name: '化机浆',
    description: '化学预处理+机械磨解，得率80-95%，兼具化学浆和机械浆优点',
    category: '制浆工艺',
    feedstock: ['木片', 'NaOH', 'Na₂SO₃/H₂O₂'],
    products: ['化机浆(CTMP/BCTMP/APMP)'],
    byproducts: ['少量废液'],
    processSteps: [
      '木片筛选',
      '汽蒸软化',
      '化学浸渍',
      '反应仓(80-90℃)',
      '压力磨浆(120-130℃)',
      '消潜',
      '筛选除渣',
      '漂白',
      '成品浆'
    ],
    status: 'commercial',
    temperature: '80-130℃',
    advantages: ['得率高(80-95%)', '化学品消耗少', '污染小', '设备投资省'],
    challenges: ['能耗中高', '浆白度中等', '工艺控制复杂'],
    keyParameters: ['得率80-95%', '反应温度80-90℃', '磨浆温度120-130℃', '漂白白度66.5-73.5% ISO(国际标准白度)']
  },
  {
    id: 'deinked-pulp',
    name: '废纸脱墨浆',
    description: '废纸回收脱墨再利用，得率80-90%，环保节能',
    category: '制浆工艺',
    feedstock: ['废纸', '脱墨剂', '浮选剂'],
    products: ['脱墨浆'],
    byproducts: ['油墨污泥', '填料灰分'],
    processSteps: [
      '废纸分选',
      '碎浆',
      '除砂筛选',
      '浮选脱墨',
      '热分散',
      '漂白',
      '成品脱墨浆'
    ],
    status: 'commercial',
    advantages: ['资源循环利用', '成本低', '节能环保', '减少森林砍伐'],
    challenges: ['纤维强度下降', '胶粘物难去除', '白度受限', '废水处理'],
    keyParameters: ['碎浆浓度10-12%', '碎浆温度55℃', '浮选时间8min', '脱墨浆白度可达93.42%']
  },
  {
    id: 'linerboard',
    name: '箱板纸',
    description: '制造瓦楞纸箱的面纸，牛皮箱板纸强度高、防潮性能好',
    category: '造纸工艺',
    feedstock: ['木浆', '废纸浆', '竹浆'],
    products: ['箱板纸', '牛皮箱板纸'],
    byproducts: ['少量纸边'],
    processSteps: [
      '面层浆料制备',
      '芯层浆料制备',
      '底层浆料制备',
      '多层流浆箱',
      '多长网成型',
      '压榨脱水',
      '烘缸干燥',
      '表面施胶',
      '压光整饰',
      '卷取复卷',
      '成品'
    ],
    status: 'commercial',
    advantages: ['强度高', '防潮性好', '可多层结构', '用途广泛'],
    challenges: ['原料成本高', '质量控制严格', '设备投资大'],
    keyParameters: ['定量140-300 g/m²', '施胶度≥0.75mm', '车速可达800 m/min以上', '耐破强度、环压强度']
  },
  {
    id: 'cultural-paper',
    name: '文化纸',
    description: '用于书写印刷的纸张，包括双胶纸、铜版纸、新闻纸等',
    category: '造纸工艺',
    feedstock: ['针叶木浆', '阔叶木浆', '填料(碳酸钙等)'],
    products: ['双胶纸', '铜版纸', '新闻纸', '轻涂纸'],
    byproducts: ['纸边', '白水'],
    processSteps: [
      '浆料碎解',
      '筛选净化',
      '打浆',
      '配浆(长短纤维配比)',
      '添加填料',
      '净化除气',
      '流浆箱',
      '长网成型',
      '压榨脱水',
      '施胶',
      '烘缸干燥',
      '涂布(铜版纸)',
      '压光',
      '卷取复卷',
      '成品'
    ],
    status: 'commercial',
    advantages: ['品种多样', '应用广泛', '技术成熟', '市场需求大'],
    challenges: ['木浆依赖进口', '填料添加控制', '环保要求高'],
    keyParameters: ['定量60-90 g/m²(普通)', '白度A等≥92%', '平滑度高', 'pH值稳定']
  },
  {
    id: 'white-cardboard',
    name: '白卡纸',
    description: '涂布包装材料，高挺度、高平滑度，可降解，满足食品级标准',
    category: '造纸工艺',
    feedstock: ['漂白硫酸盐木浆', '涂布颜料'],
    products: ['白卡纸', '食品卡纸'],
    byproducts: ['纸边', '涂布废料'],
    processSteps: [
      '面层/芯层/底层制浆',
      '打浆(350-450 mL 加拿大标准游离度CSF)',
      '流送系统',
      '独立流浆箱',
      '长网成型',
      '压榨',
      '前干燥',
      '施胶',
      '后干燥',
      '涂布(双面)',
      '干燥',
      '压光整饰',
      '卷取复卷',
      '成品'
    ],
    status: 'commercial',
    advantages: ['挺度高', '平滑度好', '印刷适性佳', '可降解', '食品级安全'],
    challenges: ['成本较高', '多层结构控制', '防伪技术要求'],
    keyParameters: ['定量160-600 g/m²', '白度A等≥92%', '涂布量10-15 g/m²/面', '车速可达1000 m/min以上']
  },
  {
    id: 'tissue-paper',
    name: '卫生纸',
    description: '生活用纸，起皱工艺是核心特征，柔软吸水',
    category: '造纸工艺',
    feedstock: ['针叶木浆', '阔叶木浆', 'CMC助剂'],
    products: ['卫生纸', '纸巾'],
    byproducts: ['纸边'],
    processSteps: [
      '木浆碎解',
      '除砂',
      '磨浆',
      '长短纤维配比(3:7或4:6)',
      '添加助剂',
      '流浆箱',
      '网部成型/脱水',
      '压榨',
      '杨克烘缸干燥',
      '起皱(核心工序)',
      '卷取大轴纸',
      '复卷分层',
      '压虚线',
      '裁切包装',
      '成品'
    ],
    status: 'commercial',
    advantages: ['柔软吸水', '可冲散', '品种多样', '市场需求稳定'],
    challenges: ['纤维帚化控制', '起皱参数调节', '掉粉控制'],
    keyParameters: ['起皱速比1.2-1.3', '纸页干度~93%', '刮刀角度18-30°', '纵向伸长率提高8倍']
  }
];

export const pulpPaperCategories = [
  { id: 'pulping', label: '制浆工艺', category: '制浆工艺' },
  { id: 'papermaking', label: '造纸工艺', category: '造纸工艺' },
];

export interface AirRoute {
  id: string;
  name: string;
  description: string;
  category: string;
  feedstock: string[];
  products: string[];
  byproducts: string[];
  processSteps: string[];
  status: 'commercial' | 'pilot' | 'research';
  temperature?: string;
  pressure?: string;
  purity?: string;
  advantages?: string[];
  challenges?: string[];
  keyParameters?: string[];
  energyConsumption?: string;
}

export const airRoutesData: AirRoute[] = [
  {
    id: 'cryogenic-oxygen',
    name: '深冷法制氧',
    description: '基于空气中各组分沸点差异进行低温精馏分离，氧纯度99.5%-99.999%，大型装置单套最大可达120,000 Nm³/h',
    category: '氧气制备',
    feedstock: ['空气'],
    products: ['氧气(≥99.6%)', '氮气', '氩气'],
    byproducts: ['稀有气体'],
    processSteps: [
      '空气压缩',
      '预冷',
      '净化(分子筛吸附)',
      '换热(主换热器)',
      '膨胀制冷',
      '精馏(双塔系统)',
      '产品分离'
    ],
    status: 'commercial',
    temperature: '-170~-185°C',
    pressure: '0.5-1.0 MPa',
    purity: '99.5%-99.999%',
    advantages: ['氧纯度高', '规模大', '能耗低(0.3-0.6 kWh/Nm³)', '氧回收率>95%', '连续运行>2年'],
    challenges: ['启动时间长(数小时)', '设备投资大', '操作复杂'],
    keyParameters: ['氧纯度99.5%-99.999%', '氧回收率>95%', '单位能耗0.3-0.6 kWh/Nm³', '单套最大120,000 Nm³/h', '运行周期>2年'],
    energyConsumption: '0.3-0.6 kWh/Nm³ O₂'
  },
  {
    id: 'psa-oxygen',
    name: '变压吸附法制氧(PSA/VPSA)',
    description: '利用沸石分子筛优先吸附氮气的特性，通过压力变化实现氧氮分离，氧纯度90%-97%',
    category: '氧气制备',
    feedstock: ['空气'],
    products: ['氧气(90%-97%)'],
    byproducts: ['富氮废气'],
    processSteps: [
      '空气压缩',
      '吸附(分子筛床)',
      '产品氧输出',
      '降压脱附',
      '床层再生',
      '双床切换'
    ],
    status: 'commercial',
    pressure: '变压吸附(PSA):高压吸附/低压脱附, 真空变压吸附(VPSA):真空脱附',
    purity: '变压吸附(PSA): 90%-95%, 真空变压吸附(VPSA): 93%-97%',
    advantages: ['启动快(~30分钟)', '投资低', '操作简单', '适合中小规模'],
    challenges: ['氧纯度有限', '能耗较高', '规模受限(~500 Nm³/h以下)'],
    keyParameters: ['PSA纯度90%-95%', 'VPSA纯度93%-97%', '启动时间~30分钟', '规模<500 Nm³/h'],
    energyConsumption: '中等'
  },
  {
    id: 'membrane-oxygen',
    name: '膜分离法制氧',
    description: '利用氧气在高分子膜中的渗透速率快于氮气的特性，获得富氧空气(30%-45%)',
    category: '氧气制备',
    feedstock: ['空气'],
    products: ['富氧空气(30%-45%)'],
    byproducts: ['富氮气体'],
    processSteps: [
      '空气预处理',
      '膜分离单元',
      '氧气渗透',
      '富氧收集',
      '产品输出'
    ],
    status: 'commercial',
    purity: '30%-45%',
    advantages: ['几乎无运动部件', '极低能耗', '模块化部署', '启动快(<5分钟)', '维护简单'],
    challenges: ['氧纯度低', '仅能获得富氧空气', '膜寿命有限'],
    keyParameters: ['氧纯度30%-45%', '启动时间<5分钟', '膜材料:聚砜/聚酰亚胺'],
    energyConsumption: '极低'
  },
  {
    id: 'cryogenic-nitrogen',
    name: '深冷法制氮',
    description: '与氧气在同一套双塔精馏系统中联产，上塔顶部产出高纯氮气(最高99.999%)',
    category: '氮气制备',
    feedstock: ['空气'],
    products: ['氮气(≥99.999%)', '氧气'],
    byproducts: ['氩气', '稀有气体'],
    processSteps: [
      '空气压缩',
      '预冷净化',
      '换热冷却',
      '双塔精馏',
      '上塔顶部提氮',
      '产品分离'
    ],
    status: 'commercial',
    temperature: '-195.8°C(氮沸点)',
    pressure: '上塔1.2-1.3 bar',
    purity: '最高99.999%',
    advantages: ['氮纯度极高', '大规模联产', '能耗低(联产摊薄)', '成本最低(大规模)'],
    challenges: ['启动时间长', '设备投资大', '适合大规模需求'],
    keyParameters: ['氮纯度最高99.999%', '上塔压力1.2-1.3 bar', '大规模联产O₂+N₂'],
    energyConsumption: '较低(联产摊薄)'
  },
  {
    id: 'psa-nitrogen',
    name: '变压吸附法制氮(PSA)',
    description: '利用碳分子筛(CMS)优先吸附氧气的特性，氮气纯度97%-99.999%',
    category: '氮气制备',
    feedstock: ['空气'],
    products: ['氮气(97%-99.999%)'],
    byproducts: ['富氧废气'],
    processSteps: [
      '空气压缩',
      '吸附(碳分子筛)',
      '产品氮输出',
      '降压脱附',
      '床层再生',
      '双床切换'
    ],
    status: 'commercial',
    purity: '97%-99.999%',
    advantages: ['投资低', '操作简单', '适合现场制氮', '启动快(~30分钟)'],
    challenges: ['能耗中等', '规模有限(1-3000 Nm³/h)'],
    keyParameters: ['氮纯度97%-99.999%', '产能1-3000 Nm³/h', '启动时间~30分钟', '吸附剂:碳分子筛(CMS)'],
    energyConsumption: '中等'
  },
  {
    id: 'membrane-nitrogen',
    name: '膜分离法制氮',
    description: '氧气(快气)优先渗透，氮气(慢气)留在非渗透侧成为产品，纯度95%-99.9%',
    category: '氮气制备',
    feedstock: ['空气'],
    products: ['氮气(95%-99.9%)'],
    byproducts: ['富氧渗透气'],
    processSteps: [
      '空气预处理',
      '膜分离单元',
      '氧气渗透',
      '氮气截留',
      '产品收集'
    ],
    status: 'commercial',
    purity: '95%-99.9%',
    advantages: ['无运动部件', '极低维护', '模块化', '可户外安装', '能耗最低'],
    challenges: ['氮纯度有限', '适合低纯度需求'],
    keyParameters: ['氮纯度95%-99.9%', '无运动部件', '模块化部署'],
    energyConsumption: '最低'
  },
  {
    id: 'cryogenic-argon',
    name: '深冷法提取氩气',
    description: '从空分装置上塔中部抽取氩馏分(含Ar 8%-15%)，经粗氩塔和精氩塔精馏获得纯氩≥99.999%',
    category: '氩气制备',
    feedstock: ['氩馏分(空分副产)'],
    products: ['氩气(≥99.999%)'],
    byproducts: ['氧气', '氮气'],
    processSteps: [
      '氩馏分抽取',
      '粗氩塔精馏',
      '粗氩(Ar 95%-98%)',
      '加氢除氧(传统)',
      '脱水',
      '精氩塔脱氮',
      '纯氩产品'
    ],
    status: 'commercial',
    temperature: '-186.0°C(氩沸点)',
    purity: '≥99.999%(5N)',
    advantages: ['氩纯度高', '全精馏制氩无需加氢', '氩回收率70%-85%', '安全高效'],
    challenges: ['工艺复杂', '投资大', '依赖空分装置'],
    keyParameters: ['氩回收率70%-85%', '纯度≥99.999%(5N,即五个九)', '电子级可达6N', '全精馏制氩O₂<1 ppm(百万分率)'],
    energyConsumption: '中等'
  },
  {
    id: 'helium-extraction',
    name: '天然气提氦',
    description: '从含氦天然气(He 0.3%-7%)中深冷分离提取氦气，纯化至He≥99.999%(5N)，可液化至4.2K',
    category: '氦气制备',
    feedstock: ['含氦天然气'],
    products: ['氦气(≥99.999%)', '液氦'],
    byproducts: ['天然气', '氮气'],
    processSteps: [
      '天然气预处理',
      '脱酸脱水脱汞',
      '低温分离浓缩',
      '粗氦(He 50%-70%)',
      '变压吸附(PSA)/变温吸附(TSA)纯化',
      '膜分离精制',
      '纯氦(≥99.999%)',
      '液化(4.2K)'
    ],
    status: 'commercial',
    temperature: '4.2K(-268.9°C)液化',
    purity: '≥99.999%(5N,即五个九)',
    advantages: ['唯一经济可行路线', '氦纯度高', '可液化运输', '战略资源'],
    challenges: ['氦资源分布不均', '中国90%以上依赖进口', '工艺复杂', '投资巨大'],
    keyParameters: ['天然气氦含量0.3%-7%', '纯度≥99.999%(五个九)', '液化温度4.2K', '中国氦资源<2%'],
    energyConsumption: '高'
  },
  {
    id: 'smr-hydrogen',
    name: '天然气蒸汽转化制氢(SMR)',
    description: '天然气与水蒸气在催化剂作用下反应制氢，全球主流制氢路线，占比约48%',
    category: '氢气制备',
    feedstock: ['天然气(CH₄)', '水蒸气'],
    products: ['氢气(97%-99.999%)'],
    byproducts: ['CO₂', 'CO'],
    processSteps: [
      '原料预处理',
      '脱硫',
      '一次转化(700-850℃)',
      '水气变换',
      'CO₂脱除',
      'PSA纯化',
      '产品氢'
    ],
    status: 'commercial',
    temperature: '700-850℃',
    purity: '97%-99.999%(经PSA)',
    advantages: ['技术成熟', '成本最低(1.0-2.0美元/kg)', '规模大', '全球占比48%'],
    challenges: ['碳排放高(~9.4 kg CO₂/kg H₂)', '依赖天然气资源'],
    keyParameters: ['制氢成本1.0-2.0美元/kg', '碳排放~9.4 kg CO₂/kg H₂', '转化温度700-850℃', 'Ni催化剂'],
    energyConsumption: '中等'
  },
  {
    id: 'coal-gasification-hydrogen',
    name: '煤气化制氢',
    description: '煤与水蒸气反应生成合成气，经水气变换和PSA纯化制氢，中国占比约62%',
    category: '氢气制备',
    feedstock: ['煤', '水蒸气'],
    products: ['氢气(>99.5%)'],
    byproducts: ['CO₂', 'CO', '灰渣'],
    processSteps: [
      '煤粉制备',
      '气化反应',
      '合成气净化',
      '水气变换',
      'CO₂脱除',
      'PSA纯化',
      '产品氢'
    ],
    status: 'commercial',
    temperature: '1200-1400℃',
    purity: '>99.5%',
    advantages: ['中国富煤资源', '成本较低(1.0-1.5美元/kg)', '技术成熟', '中国占比62%'],
    challenges: ['碳排放最高(~24 kg CO₂/kg H₂)', '环境污染', '需配套CCS'],
    keyParameters: ['制氢成本1.0-1.5美元/kg', '碳排放~24 kg CO₂/kg H₂', '气化温度1200-1400℃', '中国占比62%'],
    energyConsumption: '高'
  },
  {
    id: 'electrolysis-hydrogen',
    name: '电解水制氢',
    description: '利用电能分解水制氢，包括碱性电解(AEC)、质子交换膜(PEM)电解和固体氧化物(SOEC)高温电解，可实现零碳排放',
    category: '氢气制备',
    feedstock: ['水', '电能'],
    products: ['氢气(>99.5%)', '氧气'],
    byproducts: ['无'],
    processSteps: [
      '水预处理',
      '电解槽',
      '电解反应',
      '氢气分离',
      '纯化干燥',
      '产品氢',
      '氧气副产'
    ],
    status: 'commercial',
    temperature: '碱性AEC:60-90℃, 质子膜PEM:50-80℃, 固体氧化物SOEC:700-1000℃',
    purity: '碱性AEC:>99.5%, 质子膜PEM:>99.99%, 固体氧化物SOEC:>99.9%',
    advantages: ['零碳排放(绿氢)', '产品纯度高', '可分布式生产', '与可再生能源耦合'],
    challenges: ['成本高(4.0-7.0美元/kg)', '电耗大', '质子膜PEM/固体氧化物SOEC技术待成熟'],
    keyParameters: ['碱性电解(AEC)电耗4.5-5.5 kWh/Nm³', '质子交换膜(PEM)电耗3.8-5.0 kWh/Nm³', '固体氧化物(SOEC)电耗2.5-3.5 kWh/Nm³', '碱性电解(AEC)最成熟★★★★★'],
    energyConsumption: '碱性电解(AEC):4.5-5.5 kWh/Nm³ H₂'
  }
];

export const airCategories = [
  { id: 'oxygen', label: '氧气制备', category: '氧气制备' },
  { id: 'nitrogen', label: '氮气制备', category: '氮气制备' },
  { id: 'argon', label: '氩气制备', category: '氩气制备' },
  { id: 'helium', label: '氦气制备', category: '氦气制备' },
  { id: 'hydrogen', label: '氢气制备', category: '氢气制备' },
];

export interface BiologicalRoute {
  id: string;
  name: string;
  description: string;
  category: string;
  feedstock: string[];
  products: string[];
  byproducts: string[];
  processSteps: string[];
  status: 'commercial' | 'pilot' | 'research';
  temperature?: string;
  pressure?: string;
  keyParameters?: string[];
  advantages?: string[];
  challenges?: string[];
  applications?: string[];
}

export const biologicalRoutesData: BiologicalRoute[] = [
  {
    id: 'total-synthesis-api',
    name: '全合成路线',
    description: '以基本化工原料出发，通过多步有机化学反应逐步构建目标药物分子完整骨架',
    category: '化学原料药制造',
    feedstock: ['苯', '甲苯', '乙烯', '基本化工原料'],
    products: ['化学原料药(API)'],
    byproducts: ['有机溶剂', '副产物'],
    processSteps: [
      '原料准备',
      '缩合反应',
      '取代反应',
      '酰化反应',
      '氧化还原',
      '环化反应',
      '重排反应',
      '分离纯化',
      '结晶干燥',
      '成品API(原料药)'
    ],
    status: 'commercial',
    temperature: '室温~200℃',
    pressure: '常压~20 MPa',
    keyParameters: ['温度控制±0.5~2℃', '压力控制10~20 MPa', 'pH控制', '溶剂选择'],
    advantages: ['原料易得', '成本可控', '工艺成熟', '规模大'],
    challenges: ['反应步骤多', '选择性控制难', '杂质控制要求高', '三废处理'],
    applications: ['布洛芬', '阿司匹林', '对乙酰氨基酚']
  },
  {
    id: 'semi-synthesis-api',
    name: '半合成路线',
    description: '以微生物发酵产生的天然产物为起始原料，通过化学修饰进行结构改造',
    category: '化学原料药制造',
    feedstock: ['发酵产物', '天然母核', '前体化合物'],
    products: ['半合成药物'],
    byproducts: ['副产物', '溶剂'],
    processSteps: [
      '发酵生产',
      '天然产物提取',
      '母核分离',
      '侧链裂解',
      '化学修饰',
      '引入新侧链',
      '分离纯化',
      '成品'
    ],
    status: 'commercial',
    temperature: '室温~150℃',
    pressure: '常压',
    keyParameters: ['发酵周期48-200h', '酶催化效率', '化学修饰选择性', '纯度控制'],
    advantages: ['利用天然产物', '减少合成步骤', '成本较低', '环保性好'],
    challenges: ['依赖发酵产物', '工艺复杂', '质量控制难', '批次一致性'],
    applications: ['半合成青霉素', '半合成头孢菌素', '他汀类药物']
  },
  {
    id: 'chiral-synthesis',
    name: '手性药物合成',
    description: '通过不对称催化合成或酶催化手性合成，获得单一构型手性药物',
    category: '化学原料药制造',
    feedstock: ['消旋体', '前手性化合物', '手性催化剂'],
    products: ['手性药物'],
    byproducts: ['副产物'],
    processSteps: [
      '底物准备',
      '手性催化剂制备',
      '不对称催化',
      '反应监控',
      '产物分离',
      '对映选择性检测',
      '纯化精制',
      '成品'
    ],
    status: 'commercial',
    temperature: '-40℃~100℃',
    pressure: '常压~10 MPa',
    keyParameters: ['对映选择性(ee值,即对映体过量)≥95%', '催化剂效率', '反应条件控制', '产物纯度'],
    advantages: ['选择性高', '原子经济性好', '绿色环保', '产物纯度高'],
    challenges: ['催化剂成本高', '反应条件苛刻', '放大生产难', '质量控制复杂'],
    applications: ['S-布洛芬', '西他列汀', '手性氨基酸']
  },
  {
    id: 'microbial-fermentation',
    name: '微生物发酵法',
    description: '利用微生物代谢产生目标产物，是生物药制造的核心技术之一',
    category: '生物药制造',
    feedstock: ['碳源', '氮源', '无机盐', '微生物菌种'],
    products: ['抗生素', '氨基酸', '维生素', '有机酸'],
    byproducts: ['菌体', '代谢副产物', 'CO₂'],
    processSteps: [
      '菌种选育',
      '种子培养',
      '发酵罐准备',
      '发酵培养',
      '过程控制',
      '破壁/收获',
      '过滤分离',
      '沉淀/萃取',
      '离心干燥',
      '精制纯化'
    ],
    status: 'commercial',
    temperature: '25~37℃',
    pressure: '常压',
    keyParameters: ['发酵温度25-37℃', 'pH 6.0-7.5', '溶氧≥30%', '搅拌100-600 rpm(转/分钟)', '发酵周期48-200h'],
    advantages: ['条件温和', '选择性高', '绿色环保', '产物多样'],
    challenges: ['发酵周期长', '无菌要求高', '过程控制复杂', '成本较高'],
    applications: ['青霉素', '红霉素', '谷氨酸', '维生素C']
  },
  {
    id: 'mammalian-cell-culture',
    name: '哺乳动物细胞培养',
    description: '利用中国仓鼠卵巢细胞(CHO)等哺乳动物细胞表达生产重组蛋白、单克隆抗体等生物药',
    category: '生物药制造',
    feedstock: ['细胞株', '培养基', '生长因子', '气体(O₂/CO₂)'],
    products: ['单克隆抗体', '重组蛋白', '疫苗'],
    byproducts: ['细胞碎片', '代谢产物'],
    processSteps: [
      '细胞株构建',
      '种子细胞扩增',
      '生物反应器准备',
      '细胞培养',
      '过程监控',
      '收获',
      '细胞分离',
      '纯化',
      '制剂'
    ],
    status: 'commercial',
    temperature: '37℃',
    pressure: '常压',
    keyParameters: ['表达量5-10 g/L', '细胞密度10-20×10⁶/mL', '培养周期7-14天', '纯度>95%'],
    advantages: ['表达量高', '产物活性好', '规模化生产', '质量可控'],
    challenges: ['成本高', '工艺复杂', '质量要求严格', '放大生产难'],
    applications: ['阿达木单抗', '帕博利珠单抗', 'EPO(促红细胞生成素)', '胰岛素']
  },
  {
    id: 'downstream-purification',
    name: '下游分离纯化',
    description: '生物药下游纯化是决定产品质量和成本的关键环节，纯化步骤占总成本50%-80%',
    category: '生物药制造',
    feedstock: ['发酵液', '细胞培养上清', '粗提物'],
    products: ['纯化生物药'],
    byproducts: ['杂质', '废液'],
    processSteps: [
      '细胞收获',
      '细胞破碎',
      '离心分离',
      '捕获(亲和色谱)',
      '中度纯化(离子交换IEX/疏水层析HIC)',
      '精制(分子排阻层析SEC)',
      '病毒灭活/去除',
      '超滤/纳滤',
      '浓缩置换',
      '成品'
    ],
    status: 'commercial',
    temperature: '4℃~室温',
    pressure: '常压',
    keyParameters: ['纯度>95%', '收率>80%', '病毒去除>4 log(对数级去除)', '内毒素<0.5 EU/mL(EU为内毒素单位)'],
    advantages: ['纯度高', '质量可控', '安全性好', '连续化趋势'],
    challenges: ['成本高', '步骤多', '收率损失', '放大生产难'],
    applications: ['单抗纯化', '重组蛋白纯化', '疫苗纯化']
  },
  {
    id: 'tcm-extraction',
    name: '中药提取技术',
    description: '从中药材中提取有效成分，包括传统方法和现代提取技术',
    category: '中药制造',
    feedstock: ['中药材', '溶剂', '辅料'],
    products: ['中药提取物', '有效成分'],
    byproducts: ['药渣', '溶剂'],
    processSteps: [
      '药材预处理',
      '提取(煎煮/浸渍/渗漉)',
      '过滤分离',
      '浓缩',
      '分离纯化',
      '干燥',
      '粉碎',
      '包装'
    ],
    status: 'commercial',
    temperature: '室温~100℃',
    pressure: '常压~15 MPa',
    keyParameters: ['提取温度', '提取时间', '溶剂用量', '有效成分含量'],
    advantages: ['方法多样', '适用范围广', '技术成熟', '成本可控'],
    challenges: ['提取效率', '成分复杂', '质量控制难', '标准化程度低'],
    applications: ['中药颗粒', '中药浸膏', '有效成分提取物']
  },
  {
    id: 'supercritical-co2-extraction',
    name: '超临界CO₂提取',
    description: '利用CO₂在超临界状态溶解有效成分，无溶剂残留、选择性高',
    category: '中药制造',
    feedstock: ['中药材', 'CO₂', '夹带剂'],
    products: ['高纯度提取物'],
    byproducts: ['药渣'],
    processSteps: [
      '药材预处理',
      '超临界CO₂系统准备',
      '提取参数设置',
      '超临界提取',
      '分离',
      'CO₂回收',
      '产品收集',
      '精制'
    ],
    status: 'commercial',
    temperature: '31.1℃以上',
    pressure: '7.38 MPa以上',
    keyParameters: ['温度31.1℃以上', '压力7.38 MPa以上', 'CO₂流量', '提取时间'],
    advantages: ['无溶剂残留', '选择性高', '适合脂溶性成分', '环保'],
    challenges: ['设备投资大', '操作压力高', '适用范围有限', '成本较高'],
    applications: ['挥发油提取', '脂溶性成分提取', '精油提取']
  },
  {
    id: 'solid-dosage-form',
    name: '固体制剂生产',
    description: '片剂、胶囊、颗粒剂等固体制剂的生产工艺，是药品最常见剂型',
    category: '制剂生产',
    feedstock: ['原料药', '辅料', '包衣材料'],
    products: ['片剂', '胶囊', '颗粒剂'],
    byproducts: ['粉尘', '废料'],
    processSteps: [
      '原辅料准备',
      '粉碎过筛',
      '称量配料',
      '混合',
      '制粒(湿法/干法)',
      '干燥',
      '整粒',
      '压片/填充',
      '包衣',
      '包装'
    ],
    status: 'commercial',
    temperature: '室温~80℃',
    pressure: '常压',
    keyParameters: ['粒度分布', '流动性', '含量均匀度', '溶出度', '硬度'],
    advantages: ['剂型成熟', '生产效率高', '成本较低', '患者依从性好'],
    challenges: ['工艺参数控制', '质量一致性', '稳定性问题', '放大生产'],
    applications: ['片剂', '硬胶囊', '颗粒剂', '散剂']
  },
  {
    id: 'injectable-preparation',
    name: '注射剂生产',
    description: '水针、粉针、大输液等注射剂的生产，要求严格的无菌保证',
    category: '制剂生产',
    feedstock: ['原料药', '注射用水', '辅料', '包装材料'],
    products: ['注射剂'],
    byproducts: ['废液', '废料'],
    processSteps: [
      '原辅料准备',
      '配液',
      '过滤(0.22μm除菌)',
      '灌装',
      '封口',
      '灭菌/冻干',
      '灯检',
      '包装'
    ],
    status: 'commercial',
    temperature: '121℃灭菌',
    pressure: '常压',
    keyParameters: ['无菌保证', '内毒素<0.5 EU/mL(EU为内毒素单位)', 'pH控制', '粒子控制', '密封性'],
    advantages: ['起效快', '生物利用度高', '剂量准确', '适用于急救'],
    challenges: ['无菌要求高', '质量控制严格', '成本高', '安全性风险'],
    applications: ['水针', '粉针(冻干)', '大输液', '小容量注射剂']
  },
  {
    id: 'sustained-release-preparation',
    name: '缓控释制剂',
    description: '通过特殊工艺控制药物释放速率，实现长效、稳定给药',
    category: '制剂生产',
    feedstock: ['原料药', '缓释材料', '辅料'],
    products: ['缓释片', '控释片', '缓释胶囊'],
    byproducts: ['废料'],
    processSteps: [
      '原辅料准备',
      '缓释材料选择',
      '制粒',
      '成型',
      '包衣(功能性)',
      '释放度测试',
      '包装'
    ],
    status: 'commercial',
    temperature: '室温~80℃',
    pressure: '常压',
    keyParameters: ['释放度', '释放曲线', '生物利用度', '稳定性'],
    advantages: ['减少给药次数', '血药浓度平稳', '提高患者依从性', '减少副作用'],
    challenges: ['工艺复杂', '质量控制难', '成本较高', '释放机制研究'],
    applications: ['硝苯地平控释片', '二甲双胍缓释片', '骨架型缓释片']
  },
  {
    id: 'targeted-preparation',
    name: '靶向制剂',
    description: '脂质体、纳米粒、ADC等靶向制剂，实现药物精准递送',
    category: '制剂生产',
    feedstock: ['原料药', '载体材料', '靶向分子'],
    products: ['脂质体', '纳米粒', 'ADC(抗体药物偶联物)'],
    byproducts: ['废液'],
    processSteps: [
      '载体材料制备',
      '药物包载',
      '靶向修饰',
      '纯化',
      '表征',
      '制剂',
      '质量控制',
      '包装'
    ],
    status: 'commercial',
    temperature: '4℃~室温',
    pressure: '常压',
    keyParameters: ['包封率', '粒径分布', '靶向效率', '稳定性'],
    advantages: ['靶向性强', '减少副作用', '提高疗效', '降低剂量'],
    challenges: ['工艺复杂', '成本高', '稳定性差', '放大生产难'],
    applications: ['脂质体药物', '白蛋白紫杉醇', 'ADC(抗体偶联)药物']
  }
];

export const biologicalCategories = [
  { id: 'chemical-api', label: '化学原料药制造', category: '化学原料药制造' },
  { id: 'biological-drug', label: '生物药制造', category: '生物药制造' },
  { id: 'tcm', label: '中药制造', category: '中药制造' },
  { id: 'formulation', label: '制剂生产', category: '制剂生产' },
];

export interface ChemicalRoute {
  id: string;
  name: string;
  description: string;
  category: string;
  feedstock: string[];
  /** 各原料实际投入的工序下标列表；缺省时默认投入第一道工序 */
  feedstockEntry?: Record<string, number[]>;
  products: string[];
  byproducts: string[];
  processSteps: string[];
  status: 'commercial' | 'pilot' | 'research';
  temperature?: string;
  pressure?: string;
  keyParameters?: string[];
  advantages?: string[];
  challenges?: string[];
  applications?: string[];
}

export const chemicalCategories = [
  { id: 'chlor-alkali', label: '氯碱工业', category: '氯碱工业' },
  { id: 'fluorine', label: '氟化工', category: '氟化工' },
  { id: 'sulfuric-acid', label: '硫酸工业', category: '硫酸工业' },
  { id: 'ammonia', label: '合成氨工业', category: '合成氨工业' },
  { id: 'carbide', label: '电石工业', category: '电石工业' },
  { id: 'fine-chemicals', label: '精细化工', category: '精细化工' },
  { id: 'environmental', label: '环保', category: '环保' },
];

export const chemicalRoutesData: ChemicalRoute[] = [
  {
    id: 'ion-exchange-membrane',
    name: '离子膜法电解',
    description: '利用阳离子交换膜将电解槽分隔为阳极室和阴极室，通过电解饱和氯化钠水溶液制取烧碱、氯气和氢气的主流工艺',
    category: '氯碱工业',
    feedstock: ['原盐', '水', '电力'],
    products: ['烧碱(NaOH)', '氯气(Cl₂)', '氢气(H₂)'],
    byproducts: ['淡盐水', '盐泥'],
    processSteps: [
      '一次盐水精制',
      '二次盐水精制(螯合树脂)',
      '离子膜电解',
      '淡盐水脱氯处理',
      '产品精制与蒸发'
    ],
    status: 'commercial',
    temperature: '80-90℃(电解槽)',
    pressure: '常压',
    keyParameters: [
      '直流电耗2100-2200kWh/t碱',
      '电流效率95%-96%',
      '离子膜寿命2-3年',
      '盐水Ca²⁺/Mg²⁺<0.05 ppm(百万分率)'
    ],
    advantages: [
      '总能耗最低',
      '烧碱纯度高(50%碱含NaCl仅50-60ppm)',
      '无汞/石棉污染',
      '可连续生产，自动化程度高',
      '设备占地面积小'
    ],
    challenges: [
      '对盐水质量要求极高',
      '离子膜价格昂贵',
      '膜寿命有限',
      '对电流波动敏感'
    ],
    applications: [
      '氧化铝生产',
      '造纸工业',
      '粘胶短纤生产',
      'PVC(聚氯乙烯)制造',
      '盐酸合成',
      '氢燃料电池'
    ]
  },
  {
    id: 'zero-gap-cell',
    name: '零极距电解槽技术',
    description: '膜极距电解槽技术，弹性阴极网紧贴离子膜，极距≈0，显著降低槽电压和能耗',
    category: '氯碱工业',
    feedstock: ['精制盐水', '纯水', '电力'],
    products: ['烧碱', '氯气', '氢气'],
    byproducts: ['淡盐水'],
    processSteps: [
      '盐水精制',
      '零极距电解',
      '产品分离',
      '淡盐水循环处理'
    ],
    status: 'commercial',
    temperature: '80-90℃',
    keyParameters: [
      '节电约140kWh/t碱',
      '极距≈0',
      '普及率>80%'
    ],
    advantages: [
      '显著降低槽电压',
      '节电效果明显',
      '技术成熟度高',
      '投资回收期短'
    ],
    challenges: [
      '阴极网制造精度要求高',
      '膜损伤风险',
      '维护要求严格'
    ],
    applications: [
      '大型氯碱装置',
      '新建氯碱项目',
      '老装置改造'
    ]
  },
  {
    id: 'oxygen-depolarized-cathode',
    name: '氧阴极电解技术',
    description: '阴极通氧气替代析氢反应，大幅降低槽电压，吨碱电耗降至约1900kWh，是未来发展方向',
    category: '氯碱工业',
    feedstock: ['精制盐水', '纯水', '氧气', '电力'],
    products: ['烧碱', '氯气'],
    byproducts: ['无氢气产生'],
    processSteps: [
      '盐水精制',
      '氧阴极电解',
      '产品分离',
      '氧气循环利用'
    ],
    status: 'pilot',
    temperature: '80-90℃',
    keyParameters: [
      '电耗约1900kWh/t碱',
      '降幅约26.7%',
      '氧气利用率'
    ],
    advantages: [
      '大幅降低电耗',
      '节能效果显著',
      '符合绿色发展理念',
      '减少碳排放'
    ],
    challenges: [
      '氧阴极催化剂成本高',
      '氧气供应系统复杂',
      '技术成熟度待提升',
      '投资成本较高'
    ],
    applications: [
      '示范装置',
      '未来大型氯碱装置',
      '绿电配套项目'
    ]
  },
  {
    id: 'fluorite-to-hf',
    name: '萤石法生产氢氟酸',
    description: '以萤石(氟化钙)和硫酸为原料，通过回转反应炉高温反应制取无水氟化氢的基础工艺',
    category: '氟化工',
    feedstock: ['萤石粉(CaF₂≥97%)', '浓硫酸'],
    products: ['无水氢氟酸(AHF)'],
    byproducts: ['硫酸钙(石膏)', '含氟尾气'],
    processSteps: [
      '萤石粉干燥',
      '预混料(萤石:硫酸=1:1.2~1.3)',
      '回转反应炉反应(280±10℃)',
      '粗馏塔除杂',
      '脱气塔除SiF₄/SO₂',
      '精馏塔提纯'
    ],
    status: 'commercial',
    temperature: '280±10℃(反应炉)',
    pressure: '常压~微负压',
    keyParameters: [
      '萤石:硫酸配比1:1.2~1.3',
      '回转炉气相温度280±10℃',
      '精馏塔顶温度19.6±0.5℃',
      '萤石CaF₂含量≥97%'
    ],
    advantages: [
      '工艺成熟可靠',
      '产品纯度高',
      '技术门槛相对较低',
      '设备投资适中'
    ],
    challenges: [
      '萤石资源日益稀缺',
      '硫酸消耗量大',
      '尾气处理要求高',
      '石膏渣处理'
    ],
    applications: [
      '氟化铝生产',
      '含氟制冷剂',
      '含氟聚合物',
      '电子级氢氟酸',
      '含氟精细化学品'
    ]
  },
  {
    id: 'ptfe-production',
    name: '聚四氟乙烯(PTFE)生产',
    description: '以R22为原料，高温裂解制取四氟乙烯(TFE)单体，再通过悬浮或分散聚合生产聚四氟乙烯',
    category: '氟化工',
    feedstock: ['R22(二氟一氯甲烷)'],
    products: ['聚四氟乙烯(PTFE)'],
    byproducts: ['HCl', '低聚物'],
    processSteps: [
      'R22高温裂解(700-900℃)',
      'TFE(四氟乙烯)单体提纯',
      '悬浮聚合/分散聚合',
      '产物后处理',
      '干燥粉碎'
    ],
    status: 'commercial',
    temperature: '700-900℃(裂解)',
    pressure: '聚合压力0.5-2MPa',
    keyParameters: [
      '裂解温度700-900℃',
      'TFE(四氟乙烯)纯度>99.99%',
      '聚合温度10-90℃',
      '分子量控制'
    ],
    advantages: [
      '产品性能优异',
      '耐温范围宽(-200~260℃)',
      '耐所有化学试剂',
      '摩擦系数最低',
      '介电性能优异'
    ],
    challenges: [
      '裂解过程易结焦',
      'TFE单体不稳定',
      '聚合过程控制复杂',
      '加工成型困难'
    ],
    applications: [
      '密封材料',
      '防腐衬里',
      '电气绝缘',
      '不粘涂层',
      '医疗器材'
    ]
  },
  {
    id: 'pvdf-production',
    name: '聚偏氟乙烯(PVDF)生产',
    description: '以偏氟乙烯(VDF)为单体，通过乳液或悬浮聚合生产聚偏氟乙烯，是新能源领域关键材料',
    category: '氟化工',
    feedstock: ['VDF(偏氟乙烯)'],
    products: ['聚偏氟乙烯(PVDF)'],
    byproducts: ['未反应单体'],
    processSteps: [
      'VDF单体制备',
      '乳液聚合/悬浮聚合',
      '产物分离',
      '干燥造粒',
      '质量检测'
    ],
    status: 'commercial',
    temperature: '聚合温度50-80℃',
    pressure: '聚合压力1-3MPa',
    keyParameters: [
      '聚合温度50-80℃',
      '聚合压力1-3MPa',
      '分子量与结晶度控制',
      '纯度要求'
    ],
    advantages: [
      '耐化学性优异',
      '机械强度高',
      '耐候性好',
      '易加工成型',
      '新能源应用前景广阔'
    ],
    challenges: [
      'VDF单体制备难度大',
      '聚合条件苛刻',
      '产品质量稳定性',
      '成本控制'
    ],
    applications: [
      '锂电池正极粘结剂',
      '光伏背板膜',
      '储能电池隔膜涂层',
      '化工管道',
      '电线电缆'
    ]
  },
  {
    id: 'hfo-refrigerant',
    name: '第四代制冷剂(HFOs)生产',
    description: '以含氟中间体为原料，通过催化氟化或脱卤化氢反应制备低GWP值(<1)的第四代环保制冷剂',
    category: '氟化工',
    feedstock: ['含氟中间体', 'HF(氟化氢)', '催化剂'],
    products: ['R1234yf', 'R1234ze'],
    byproducts: ['HCl', '未反应原料'],
    processSteps: [
      '原料预处理',
      '气相催化氟化/脱卤化氢',
      '产物分离提纯',
      '质量检测',
      '包装储存'
    ],
    status: 'pilot',
    temperature: '200-400℃(催化反应)',
    pressure: '0.1-1MPa',
    keyParameters: [
      '催化反应温度200-400℃',
      '催化剂活性与选择性',
      'GWP(全球变暖潜能值)<1',
      'ODP(臭氧层损耗潜能值)=0'
    ],
    advantages: [
      'GWP(全球变暖潜能值)极低(<1)',
      'ODP(臭氧层损耗潜能值)为0',
      '环保性能优异',
      '符合国际法规要求',
      '未来发展前景广阔'
    ],
    challenges: [
      '催化剂开发难度大',
      '生产成本高',
      '技术壁垒高',
      '市场接受度待提升'
    ],
    applications: [
      '汽车空调',
      '商用制冷',
      '家用空调',
      '热泵系统'
    ]
  },
  {
    id: 'electronic-grade-hf',
    name: '电子级氢氟酸生产',
    description: '以工业级氢氟酸为原料，通过多级精馏、吸附、过滤等提纯技术制备超高纯度电子级氢氟酸',
    category: '氟化工',
    feedstock: ['工业级氢氟酸'],
    products: ['电子级氢氟酸'],
    byproducts: ['低纯度馏分'],
    processSteps: [
      '原料预处理',
      '多级精馏提纯',
      '吸附除杂',
      '超净过滤',
      '质量检测',
      '包装储存'
    ],
    status: 'commercial',
    temperature: '常温~50℃',
    pressure: '常压~微负压',
    keyParameters: [
      '金属离子含量<1ppb(十亿分率)',
      '颗粒物控制',
      '纯度等级:电子级(EL)/超高纯(UPS)/UPS-S',
      '洁净度控制'
    ],
    advantages: [
      '产品附加值高',
      '市场需求增长快',
      '技术壁垒高',
      '利润空间大'
    ],
    challenges: [
      '提纯技术难度大',
      '洁净室要求高',
      '质量稳定性控制',
      '包装运输要求严格'
    ],
    applications: [
      '集成电路制造',
      '半导体芯片',
      '液晶面板',
      '太阳能电池',
      'LED制造'
    ]
  },
  {
    id: 'sulfur-burning',
    name: '硫磺制酸',
    description: '主流路线，全球产能约8500万吨。固体硫磺熔化后燃烧生成SO₂，经催化转化和吸收制得硫酸，流程最短、产品品质最高',
    category: '硫酸工业',
    feedstock: ['固体硫磺', '干燥空气'],
    products: ['浓硫酸(93-98%)'],
    byproducts: ['高压蒸汽', '未反应SO₂'],
    processSteps: [
      '硫磺熔化过滤(~140℃)',
      '焚硫炉燃烧(1050℃)',
      '余热回收(副产蒸汽)',
      '催化转化(3+1或3+2双转化)',
      '中间吸收',
      '二次催化转化',
      '最终吸收',
      '成品酸冷却储存'
    ],
    status: 'commercial',
    temperature: '1050℃(燃烧)',
    pressure: '常压',
    keyParameters: [
      '总转化率≥99.7%',
      '每吨酸副产1.2-1.5吨蒸汽',
      '产品酸纯度最高',
      '催化剂为V₂O₅'
    ],
    advantages: [
      '流程最短，设备最简单',
      '产品酸品质最高',
      '副产蒸汽量大',
      '建设周期短',
      '操作稳定性好'
    ],
    challenges: [
      '原料成本占60%-75%',
      '高度依赖进口硫磺',
      '硫磺价格波动影响大',
      '供应链相对脆弱'
    ],
    applications: [
      '磷肥生产',
      '高纯度大批量酸需求',
      '沿海港口周边企业'
    ]
  },
  {
    id: 'smelter-gas',
    name: '有色金属冶炼烟气制酸',
    description: '副产路线，全球产能约6000万吨。铜、锌、铅硫化矿冶炼烟气SO₂制酸，原料成本接近零，供应刚性最强',
    category: '硫酸工业',
    feedstock: ['冶炼烟气(SO₂)', '干燥空气'],
    products: ['浓硫酸'],
    byproducts: ['烟尘', '砷氟废渣'],
    processSteps: [
      '烟气收集',
      '电除尘/动力波洗涤',
      '稀酸洗涤',
      '干燥(浓硫酸脱水)',
      '催化转化',
      '吸收',
      '成品酸储存'
    ],
    status: 'commercial',
    temperature: '烟气温度400-800℃',
    pressure: '常压',
    keyParameters: [
      '烟气SO₂浓度5%-15%',
      '总转化率≥99.5%',
      '净化工段去除砷氟尘',
      '催化剂寿命管理'
    ],
    advantages: [
      '原料成本极低(接近零)',
      '环保合规强制配套',
      '污染治理兼资源回收',
      '结合冶炼余热降能耗'
    ],
    challenges: [
      '产能刚性无法灵活增产',
      '烟气成分波动大',
      '净化工段复杂投资高',
      '酸品质受烟气杂质影响'
    ],
    applications: [
      '铜锌铅镍冶炼企业配套',
      '大型冶炼基地'
    ]
  },
  {
    id: 'pyrite-roasting',
    name: '硫铁矿制酸',
    description: '中国传统主力，全球产能约2500万吨。硫铁矿焙烧制SO₂，流程最长最复杂，副产烧渣可作炼铁原料',
    category: '硫酸工业',
    feedstock: ['硫铁矿(FeS₂)', '空气'],
    products: ['浓硫酸', '烧渣(Fe₂O₃)'],
    byproducts: ['矿尘', '含砷氟废水'],
    processSteps: [
      '矿石破碎筛分',
      '沸腾炉焙烧(700-900℃)',
      '余热回收',
      '旋风+电除尘',
      '湿法净化(冷却洗涤除砷氟)',
      '干燥',
      '催化转化',
      '吸收',
      '成品酸储存'
    ],
    status: 'commercial',
    temperature: '700-900℃(焙烧)',
    pressure: '常压',
    keyParameters: [
      '矿石含硫量30%-45%',
      '焙烧反应4FeS₂+11O₂→2Fe₂O₃+8SO₂',
      '每吨酸副产0.7吨烧渣',
      '净化去除砷氟杂质'
    ],
    advantages: [
      '原料国内自给不依赖进口',
      '烧渣可综合利用抵消成本',
      '适合矿产资源丰富地区',
      '铁硫联产模式'
    ],
    challenges: [
      '工艺流程最复杂',
      '装备投资维护成本最高',
      '矿石杂质多净化负担重',
      '单位酸成本高于硫磺酸'
    ],
    applications: [
      '硫铁矿产区周边企业',
      '安徽江西广东湖南',
      '铁硫联产企业'
    ]
  },
  {
    id: 'h2s-wsa',
    name: 'H₂S制酸/WSA湿法制酸',
    description: '变危废为商品，托普索WSA技术全球近200个地点运营。H₂S燃烧制SO₂，无需干燥直接冷凝为硫酸，无废水排放',
    category: '硫酸工业',
    feedstock: ['H₂S废气', '空气'],
    products: ['浓硫酸(98%)'],
    byproducts: ['蒸汽', '冷凝水'],
    processSteps: [
      'H₂S燃烧(炉温>1000℃)',
      '废热回收',
      '催化转化(V₂O₅)',
      'WSA冷凝器(SO₃与H₂O反应)',
      '浓硫酸冷凝析出',
      '成品酸冷却储存'
    ],
    status: 'commercial',
    temperature: '>1000℃(燃烧)',
    pressure: '常压',
    keyParameters: [
      'WSA冷凝器直接冷凝',
      '全程无需气体干燥',
      '无工艺废水产生',
      '无硫损失'
    ],
    advantages: [
      '有效处置危险废气',
      '原料来源稳定',
      '无废水排放无硫损失',
      '托普索专利技术成熟'
    ],
    challenges: [
      '规模受限于上游H₂S产量',
      'H₂S剧毒安全投入大',
      '必须配套主体装置',
      'WSA冷凝器为专有设备'
    ],
    applications: [
      '大型炼厂配套',
      '天然气净化厂',
      '煤化工园区',
      '制浆造纸厂硫回收'
    ]
  },
  {
    id: 'phosphogypsum-cement',
    name: '磷石膏制酸联产水泥',
    description: '固废资源化路线，中国年产磷石膏约8000万吨。磷石膏高温分解制SO₂，同时烧结出水泥熟料，解决堆存环保难题',
    category: '硫酸工业',
    feedstock: ['磷石膏(CaSO₄·2H₂O)', '焦炭'],
    products: ['浓硫酸', '水泥熟料'],
    byproducts: ['CO₂', '废气'],
    processSteps: [
      '磷石膏预处理(脱水去游离酸)',
      '与焦炭配料',
      '回转窑高温分解(1200-1400℃)',
      'SO₂烟气净化',
      '催化转化',
      '吸收制酸',
      'CaO烧结出水泥熟料',
      '磨细制水泥'
    ],
    status: 'commercial',
    temperature: '1200-1400℃(分解)',
    pressure: '常压',
    keyParameters: [
      '分解反应CaSO₄+2C→CaO+2CO₂+SO₂',
      'SO₂烟气浓度7%-10%',
      '能耗最高',
      '投资强度最高'
    ],
    advantages: [
      '解决磷石膏堆存环保难题',
      '酸+水泥双产品综合经济性好',
      '政策支持力度大',
      '固废资源化'
    ],
    challenges: [
      '技术复杂工业化仍在扩张',
      '能耗高碳排放大',
      '对水泥市场高度敏感',
      '投资强度最高'
    ],
    applications: [
      '贵州湖北云南磷化工集中地区',
      '磷肥磷酸企业延伸产业链'
    ]
  },
  {
    id: 'coal-gangue',
    name: '煤矸石制酸',
    description: '西南特色路线，高硫煤矸石焙烧制SO₂，联产电力，残渣可作建材，符合固废资源化政策',
    category: '硫酸工业',
    feedstock: ['高硫煤矸石', '空气'],
    products: ['硫酸', '电力'],
    byproducts: ['焙烧后矸石', 'HF/HCl废气'],
    processSteps: [
      '煤矸石破碎分选',
      '循环流化床锅炉焙烧(900-1000℃)',
      '热能回收发电',
      '烟气净化(除尘+湿法净化)',
      '催化转化',
      '吸收制酸',
      '残渣建材或矿坑充填'
    ],
    status: 'commercial',
    temperature: '900-1000℃(焙烧)',
    pressure: '常压',
    keyParameters: [
      '煤矸石含硫量3%-10%',
      '联产电力降低综合能耗',
      '烟气去除HF/HCl',
      '残渣综合利用'
    ],
    advantages: [
      '原料成本低',
      '符合固废资源化政策享优惠',
      '联产电力降低能耗',
      '残渣可作建材'
    ],
    challenges: [
      '产品酸质量稳定性较差',
      '工艺成熟度不如硫磺/硫铁矿',
      '选址必须靠近煤矿',
      '烟气HF/HCl腐蚀性强'
    ],
    applications: [
      '贵州云南四川高硫煤矿集中地区',
      '固废处置综合利用项目'
    ]
  },
  {
    id: 'waste-acid-regeneration',
    name: '废硫酸再生',
    description: '循环利用路线，焦化厂、钢铁厂、钛白粉厂等废酸高温裂解再生，实现废酸循环利用减少危废排放',
    category: '硫酸工业',
    feedstock: ['废硫酸'],
    products: ['再生硫酸'],
    byproducts: ['裂解残渣', '废气'],
    processSteps: [
      '废酸收集预处理',
      '高温裂解(800-1100℃)',
      'SO₂气体生成',
      '气体净化',
      '催化转化',
      '吸收',
      '再生硫酸储存'
    ],
    status: 'commercial',
    temperature: '800-1100℃(裂解)',
    pressure: '常压',
    keyParameters: [
      '裂解温度800-1100℃',
      '废酸组分复杂净化难度大',
      '装置规模通常较小',
      '高温裂解能耗高'
    ],
    advantages: [
      '实现废酸循环利用',
      '减少危废排放',
      '节约硫资源',
      '对特定行业经济性好'
    ],
    challenges: [
      '装置规模通常较小',
      '高温裂解能耗高',
      '废酸组分复杂净化难',
      '投资维护成本'
    ],
    applications: [
      '焦化厂',
      '钢铁厂',
      '钛白粉厂',
      '废酸产生量大的企业'
    ]
  },
  {
    id: 'pulp-paper-sulfur-loop',
    name: '制浆造纸废气制硫酸',
    description: '硫资源闭环循环路线，硫酸盐法制浆浓缩不凝气(CNCG)废气焚烧制酸，实现硫元素从蒸煮到回收的完整闭环，浆厂硫酸自给率接近100%',
    category: '硫酸工业',
    feedstock: ['浓缩不凝气(CNCG,含H₂S)', '补充元素硫(软木浆)'],
    products: ['浓硫酸(98%)'],
    byproducts: ['蒸汽', '热空气'],
    processSteps: [
      '浓缩不凝气(CNCG)收集',
      '焚烧炉燃烧(氧化为SO₂)',
      '余热锅炉回收蒸汽',
      '催化转化(V₂O₅)',
      'WSA冷凝器(SO₃与水蒸气冷凝)',
      '浓硫酸冷凝析出',
      '成品酸冷却储运'
    ],
    status: 'commercial',
    temperature: '焚烧炉高温',
    pressure: '常压',
    keyParameters: [
      '全程无需气体干燥',
      '无工艺废水产生',
      '无硫损失',
      '冷凝器热空气回用'
    ],
    advantages: [
      '原料免费(浓缩不凝气CNCG是必须处理的废气)',
      '供应安全摆脱外购依赖',
      '硫酸盐废水负荷降低90%',
      '副产蒸汽和热空气',
      '硫酸自给率接近100%'
    ],
    challenges: [
      '规模受浆厂产能限制',
      '只适用于硫酸盐法制浆厂',
      '装置投资较高',
      'WSA冷凝器为专有设备'
    ],
    applications: [
      '硫酸盐法化学浆厂',
      '大型浆纸一体化基地',
      '木质素提取联用工厂',
      '追求零排放的绿色工厂'
    ]
  },
  {
    id: 'coal-to-ammonia',
    name: '煤制氨',
    description: '中国主流路线（占76%），以煤为原料经气化制取合成气，再经变换、净化、精制和氨合成生产合成氨，原料自主可控但能耗和碳排放最高',
    category: '合成氨工业',
    feedstock: ['煤', '水', '空气'],
    products: ['合成氨(NH₃)'],
    byproducts: ['CO₂', '硫磺', '粗酚'],
    processSteps: [
      '煤气化(固定床/气流床,1300-1500℃)',
      'CO变换(高温变换+低温变换)',
      '低温甲醇洗净化(脱硫脱碳)',
      '液氮洗精制(-100℃以下除CO/CH₄)',
      '压缩(往复式/离心压缩机)',
      '氨合成(10-30MPa,400-500℃)',
      '氨分离与循环'
    ],
    status: 'commercial',
    temperature: '400-500℃(合成)',
    pressure: '10-30MPa',
    keyParameters: [
      '气化温度1300-1500℃',
      '合成压力10-30MPa',
      '综合能耗1500-1700kgce(千克标煤)/t氨',
      'CO₂排放2.8-3.5t/t氨',
      '单程转化率10-25%'
    ],
    advantages: [
      '原料自主可控，中国煤炭资源丰富',
      '可联产甲醇、乙二醇等(煤化工多联产)',
      '技术成熟，装置规模大',
      '适合中国资源禀赋'
    ],
    challenges: [
      '能耗最高，每吨氨综合能耗约1.5-1.7吨标煤',
      '碳排放极大，每吨氨排放约2.8吨CO₂',
      '流程长、投资大、水耗高',
      '环保压力大'
    ],
    applications: [
      '氮肥生产(尿素、硝酸铵)',
      '磷酸铵生产',
      '硝酸制造',
      '聚氨酯原料',
      '制冷剂'
    ]
  },
  {
    id: 'natural-gas-to-ammonia',
    name: '天然气制氨',
    description: '国际主流路线，以天然气为原料经蒸汽转化制取合成气，再经变换、净化、甲烷化和氨合成生产合成氨，能耗最低、流程紧凑',
    category: '合成氨工业',
    feedstock: ['天然气', '水蒸气', '空气'],
    products: ['合成氨(NH₃)'],
    byproducts: ['CO₂', '蒸汽'],
    processSteps: [
      '天然气脱硫预处理',
      '一段蒸汽转化(800-850℃)',
      '二段转化(配空气)',
      '高温变换+低温变换',
      'MDEA(N-甲基二乙醇胺)/苯菲尔(Benfield热钾碱)法脱碳',
      '甲烷化精制(CO+CO₂<10ppm)',
      '离心压缩',
      '氨合成(10-20MPa,400-500℃)',
      '氨分离与循环'
    ],
    status: 'commercial',
    temperature: '400-500℃(合成)',
    pressure: '10-20MPa',
    keyParameters: [
      '转化管出口温度800-850℃',
      '合成压力10-20MPa',
      '综合能耗900-1000kgce(千克标煤)/t氨',
      'CO₂排放1.6-2.0t/t氨',
      'CO+CO₂<10ppm(百万分率)'
    ],
    advantages: [
      '能耗最低，综合能耗约0.9-1.0吨标煤/吨氨',
      '流程紧凑、投资相对低',
      '自动化程度高',
      '碳排放为煤制氨的50-60%'
    ],
    challenges: [
      '中国"贫气"国情，天然气制氨占比仅约15%',
      '受国际气价波动影响大',
      '原料供应受限',
      '沿海地区依赖进口LNG'
    ],
    applications: [
      '氮肥生产',
      '工业用氨',
      '硝酸生产',
      '己内酰胺原料'
    ]
  },
  {
    id: 'green-ammonia',
    name: '绿氨(可再生氢制氨)',
    description: '将传统工艺的氢源从煤/天然气切换为可再生能源电解水制氢（绿氢），氨合成段不变或微调，是正在重塑合成氨行业的第三条路',
    category: '合成氨工业',
    feedstock: ['可再生能源电力', '水', '空气'],
    products: ['绿氨(NH₃)'],
    byproducts: ['氧气'],
    processSteps: [
      '可再生能源发电(光伏/风电)',
      '电解水制氢(碱性/质子交换膜PEM电解)',
      '空分制氮',
      '氢氮气压缩混合(3:1)',
      '柔性氨合成(低温低压催化剂)',
      '氨合成(5-10MPa,300-400℃)',
      '氨分离与循环'
    ],
    status: 'pilot',
    temperature: '300-400℃(合成)',
    pressure: '5-10MPa',
    keyParameters: [
      '电解水能耗4.2kWh/Nm³',
      '合成压力5-10MPa',
      '综合能耗约800kgce(千克标煤)/t氨(目标)',
      'CO₂排放<0.1t/t氨',
      '单程转化率20-30%'
    ],
    advantages: [
      '近零碳排放，CO₂排放<0.1t/t氨',
      '可再生能源耦合，绿色可持续',
      '低温低压催化剂活性高(钌基)',
      '契合"双碳"战略'
    ],
    challenges: [
      '可再生能源间歇性与合成氨稳定运行矛盾',
      '柔性化技术是核心难点',
      '投资成本高(5000-7000元/吨)',
      '电价敏感，经济性待提升'
    ],
    applications: [
      '绿色氮肥',
      '绿氨能源载体',
      '远洋船舶燃料',
      '氢能储运',
      '碳中和示范项目'
    ]
  },
  {
    id: 'calcium-carbide-furnace',
    name: '电石制备（矿热电炉熔炼）',
    description: '以生石灰与焦炭为原料，在矿热电炉内于1800~2300℃高温熔炼生成电石(碳化钙CaC₂)，是乙炔化工(聚氯乙烯PVC)、1,4-丁二醇(BDO)与氰胺产业链的源头工艺',
    category: '电石工业',
    feedstock: ['生石灰(CaO)', '焦炭(C)', '电力'],
    feedstockEntry: {
      '生石灰(CaO)': [0],
      '焦炭(C)': [0],
      '电力': [2],
    },
    products: ['电石(CaC₂,发气量≥295L/kg)'],
    byproducts: ['一氧化碳(CO)炉气', '除尘灰'],
    processSteps: [
      '原料准备(生石灰/焦炭破碎筛分)',
      '配料混合(钙碳比约100:60)',
      '矿热电炉熔炼(1800~2300℃)',
      '熔融电石出炉浇铸',
      '冷却破碎与筛分',
      '炉气(CO)回收净化',
      '防潮密封包装储存'
    ],
    status: 'commercial',
    temperature: '1800~2300℃(炉内反应区)',
    pressure: '常压(炉膛微正压)',
    keyParameters: [
      'CaO + 3C → CaC₂ + CO↑(强吸热反应)',
      '吨电石电耗约3000~3400kWh',
      '发气量≥295 L/kg(优等品,20℃/101.3kPa)',
      '炉气CO含量70%~90%,回收作燃料或化工原料'
    ],
    advantages: [
      '技术成熟,装置大型化(大型密闭矿热炉为主)',
      '为乙炔法聚氯乙烯(PVC)与氰胺产业链提供源头原料',
      '炉气CO高值利用可显著降耗减碳',
      '可消纳兰炭、焦炭等低成本碳源'
    ],
    challenges: [
      '高耗电行业(电费占成本约60%),电价敏感',
      '粉尘与炉气治理环保要求高',
      '石灰窑与电石炉碳排放大',
      '电石遇潮放出乙炔易燃易爆,储运安全要求高'
    ],
    applications: [
      '乙炔法聚氯乙烯(PVC)',
      '1,4-丁二醇(BDO)/聚乙烯醇(PVA)产业链',
      '氰胺产业(石灰氮/双氰胺/硝基胍)',
      '金属切割与焊接乙炔气'
    ]
  },
  {
    id: 'nitroguanidine-carbide',
    name: '硝基胍制备(电石法全流程)',
    description: '从电石开始的氰胺产业链全流程：生石灰与焦炭电炉制电石，氮化制石灰氮(氰氨化钙)，水解脱钙二聚制双氰胺，与硝酸铵熔融缩合制硝酸胍，最后经浓硫酸低温脱水硝化制得硝基胍',
    category: '精细化工',
    feedstock: ['生石灰(CaO)', '焦炭', '氮气', '水', '二氧化碳(CO₂)', '硝酸铵', '浓硫酸', '液氨'],
    feedstockEntry: {
      '生石灰(CaO)': [0],
      '焦炭': [0],
      '氮气': [1],
      '水': [2, 6],
      '二氧化碳(CO₂)': [2],
      '硝酸铵': [4],
      '浓硫酸': [5],
      '液氨': [6],
    },
    products: ['硝基胍(CH₄N₄O₂)'],
    byproducts: ['一氧化碳', '碳酸钙(白泥)', '硫酸铵母液'],
    processSteps: [
      '电石制备(电炉1800~2300℃)',
      '氮化制石灰氮(1000~1100℃)',
      '水解脱钙制单氰胺',
      '二聚制双氰胺(80~100℃)',
      '熔融缩合制硝酸胍(120~210℃)',
      '低温脱水硝化(≤20℃)',
      '稀释析出与离心分离',
      '洗涤干燥与重结晶'
    ],
    status: 'commercial',
    temperature: '1800~2300℃(电石炉)~≤20℃(硝化)',
    pressure: '常压',
    keyParameters: [
      'CaO + 3C → CaC₂ + CO (强吸热)',
      'CaC₂ + N₂ → CaCN₂ + C (42~48h, 萤石催化)',
      '双氰胺:硝酸铵=1:2 熔融缩合',
      '硝酸胍+浓硫酸脱水硝化 ≤20℃',
      '间歇法收率70%~85%, 连续流93%~96%'
    ],
    advantages: [
      '电石-石灰氮-双氰胺-硝酸胍-硝基胍一体化产业链',
      '硝酸胍法条件温和(不需高温高压)、产品纯度高',
      '微通道连续流改造后收率可达93%~96%',
      '硫酸铵母液/碳酸钙等副产物可循环利用'
    ],
    challenges: [
      '硝化反应强放热, ≤20℃控温要求严格',
      '硝酸胍/硝基胍属爆炸品, 安全管理复杂',
      '传统间歇法废酸量大(约30t/吨产品)',
      '石灰氮环节高耗能、高污染, 受环保约束强'
    ],
    applications: [
      '发射药/低易损弹药/推进剂',
      '汽车安全气囊产气药',
      '新烟碱类杀虫剂中间体(吡虫啉等)',
      '医药中间体(氨基胍/乐可安)'
    ]
  },
  {
    id: 'fenton-oxidation',
    name: '芬顿氧化污水处理',
    description: '以亚铁离子(Fe²⁺)催化双氧水(H₂O₂)分解产生羟基自由基(·OH, 氧化电位2.80V)，无选择性氧化降解难降解有机物并同步除磷；经调酸-氧化-调碱沉淀-COD/ORP反馈控制的完整污水处理流程',
    category: '环保',
    feedstock: ['难降解有机废水', '硫酸', '硫酸亚铁', '双氧水(H₂O₂)', '氢氧化钠/石灰乳'],
    feedstockEntry: {
      '难降解有机废水': [0],
      '硫酸': [1],
      '硫酸亚铁': [2],
      '双氧水(H₂O₂)': [3],
      '氢氧化钠/石灰乳': [5],
    },
    products: ['净化出水(总磷<0.5mg/L)'],
    byproducts: ['铁泥/磷酸铁污泥', '石膏(石灰乳中和时)'],
    processSteps: [
      '调节池(均质均量)',
      '前调酸(硫酸调pH至3.0±0.5)',
      '投加硫酸亚铁(Fe²⁺铁源)',
      '投加双氧水催化生成·OH',
      '氧化还原电位(ORP)在线监测反馈加药',
      '后调碱(pH 8.0~8.5)',
      '絮凝沉淀/压滤(铁泥分离)',
      '出水COD(化学需氧量)检测达标排放'
    ],
    status: 'commercial',
    temperature: '常温',
    pressure: '常压',
    keyParameters: [
      '前调酸 pH 3.0±0.5',
      'FeSO₄:H₂O₂ 体积比约 4:1',
      '·OH 氧化电位 2.80V(仅次于氟)',
      '后调碱 pH 8.0~8.5',
      '磷去除率≥95%, 出水总磷<0.5mg/L'
    ],
    advantages: [
      '·OH无选择性氧化, 可降解染料/苯酚/抗生素等顽固有机物',
      '氧化+混凝双重作用, 同步降COD(化学需氧量)与除磷',
      '技术成熟度高, 是难降解废水处理主力工艺',
      'ORP(氧化还原电位)在线反馈可实现双氧水投加"卡边"优化降本'
    ],
    challenges: [
      '产泥量大(0.5~1kg铁泥/kg COD,即化学需氧量)',
      '双氧水/酸碱药剂成本高, 投加窗口窄',
      'pH控制要求精确, 沉淀段8.0~8.5易波动',
      '双氧水受热遇碱易分解, 储运有安全风险'
    ],
    applications: [
      '磷酸铁/磷酸铁锂生产废水',
      'PCB(印制电路板)含磷废水',
      '染料/苯酚/抗生素等难降解有机废水',
      '垃圾渗滤液深度处理'
    ]
  }
];

export interface PlasticRoute {
  id: string;
  name: string;
  description: string;
  category: string;
  feedstock: string[];
  /** 各原料实际投入的工序下标列表；缺省时默认投入第一道工序 */
  feedstockEntry?: Record<string, number[]>;
  products: string[];
  byproducts: string[];
  processSteps: string[];
  processType: string;
  temperature?: string;
  pressure?: string;
  catalyst?: string;
  keyParameters?: string[];
  advantages?: string[];
  challenges?: string[];
  applications?: string[];
}

export const plasticCategories = [
  { id: 'hdpe', label: '高密度聚乙烯(HDPE)', category: 'HDPE' },
  { id: 'ldpe', label: '低密度聚乙烯(LDPE)', category: 'LDPE' },
  { id: 'uhmwpe', label: '超高分子量聚乙烯(UHMWPE)', category: 'UHMWPE' },
  { id: 'pp', label: '聚丙烯(PP)', category: 'PP' },
  { id: 'pvc', label: '聚氯乙烯(PVC)', category: 'PVC' },
  { id: 'pet', label: '聚对苯二甲酸乙二醇酯(PET)', category: 'PET' },
  { id: 'ps', label: '聚苯乙烯(PS)', category: 'PS' },
  { id: 'abs', label: 'ABS树脂', category: 'ABS' },
];

export const plasticRoutesData: PlasticRoute[] = [
  {
    id: 'hdpe-gas-phase',
    name: '高密度聚乙烯(HDPE)气相法',
    description: '乙烯在气相流化床中直接聚合，无需溶剂，流程最简短，采用超冷凝态技术撤热',
    category: 'HDPE',
    feedstock: ['乙烯', '催化剂', '氢气'],
    products: ['高密度聚乙烯'],
    byproducts: ['未反应乙烯'],
    processSteps: [
      '催化剂注入',
      '气相流化床聚合',
      '超冷凝态撤热',
      '聚合物脱气',
      '造粒包装'
    ],
    processType: '气相法',
    temperature: '80-110℃',
    pressure: '2.4 MPa',
    catalyst: '钛系、铬系、茂金属',
    advantages: ['流程简单', '无需溶剂', '投资成本低', '产品切换快'],
    challenges: ['撤热控制', '催化剂活性', '产品形态控制'],
    applications: ['管材', '中空容器', '注塑制品', '薄膜']
  },
  {
    id: 'hdpe-slurry',
    name: '高密度聚乙烯(HDPE)淤浆法',
    description: '乙烯在稀释剂中聚合，聚合物以淤浆形式存在，国内HDPE生产主要方法，全球产能占比超40%',
    category: 'HDPE',
    feedstock: ['乙烯', '稀释剂', '催化剂'],
    products: ['高密度聚乙烯'],
    byproducts: ['稀释剂回收'],
    processSteps: [
      '原料预处理',
      '淤浆聚合反应',
      '聚合物分离',
      '溶剂回收',
      '干燥造粒'
    ],
    processType: '淤浆法',
    temperature: '65-109℃',
    pressure: '4.2 MPa',
    catalyst: '齐格勒-纳塔(Z-N)、铬系、茂金属',
    advantages: ['技术成熟', '产品质量好', '双峰技术领先', '产能占比高'],
    challenges: ['溶剂处理', '能耗较高', '设备投资大'],
    applications: ['PE100管材', '油桶', '化学品桶', '编织袋']
  },
  {
    id: 'ldpe-autoclave',
    name: '低密度聚乙烯(LDPE)釜式法',
    description: '高压自由基聚合，搅拌均匀，长链支化程度高，适合生产EVA共聚物',
    category: 'LDPE',
    feedstock: ['乙烯', '引发剂', '调节剂'],
    products: ['低密度聚乙烯', 'EVA(乙烯-醋酸乙烯共聚物)'],
    byproducts: ['未反应乙烯'],
    processSteps: [
      '乙烯压缩',
      '引发剂注入',
      '釜式聚合反应',
      '产物分离',
      '挤压造粒'
    ],
    processType: '釜式法',
    temperature: '150-300℃',
    pressure: '130-250 MPa',
    catalyst: '有机过氧化物',
    advantages: ['长链支化多', '适合EVA生产', '光学性能好'],
    challenges: ['转化率较低', '能耗高', '设备投资大'],
    applications: ['EVA(乙烯-醋酸乙烯)共聚物', '电缆料', '涂层']
  },
  {
    id: 'ldpe-tubular',
    name: '低密度聚乙烯(LDPE)管式法',
    description: '高压自由基聚合，转化率高，光学性能优异，多点进料技术提高转化率',
    category: 'LDPE',
    feedstock: ['乙烯', '引发剂', '调节剂'],
    products: ['低密度聚乙烯'],
    byproducts: ['未反应乙烯'],
    processSteps: [
      '乙烯超高压压缩',
      '多点引发剂注入',
      '管式聚合反应',
      '脉冲操作',
      '产物分离造粒'
    ],
    processType: '管式法',
    temperature: '150-330℃',
    pressure: '200-350 MPa',
    catalyst: '有机过氧化物',
    advantages: ['转化率高', '光学性能优异', '适合薄膜', '多点进料灵活'],
    challenges: ['超高压设备昂贵', '能耗极高', '安全要求高'],
    applications: ['薄膜', '食品包装', '农膜', '涂层']
  },
  {
    id: 'uhmwpe-slurry',
    name: '超高分子量聚乙烯(UHMWPE)淤浆法',
    description: '超高分子量聚乙烯生产，分子量100万-1000万，极高耐磨性和抗冲击性',
    category: 'UHMWPE',
    feedstock: ['乙烯', '溶剂', '催化剂'],
    products: ['超高分子量聚乙烯'],
    byproducts: ['溶剂回收'],
    processSteps: [
      '原料预处理',
      '淤浆聚合(不调氢)',
      '聚合物分离',
      '溶剂回收',
      '干燥包装'
    ],
    processType: '淤浆法',
    temperature: '60-90℃',
    pressure: '常压~数MPa',
    catalyst: '齐格勒-纳塔(Z-N)催化剂',
    advantages: ['极高耐磨性', '极高抗冲击性', '自润滑性好', '比强度高'],
    challenges: ['加工困难', '熔体流动性极差', '成本高'],
    applications: ['防弹衣', '人工关节', '锂电池隔膜', '船舶缆绳']
  },
  {
    id: 'pp-spheripol',
    name: '聚丙烯(PP)Spheripol工艺',
    description: '全球应用最广的PP工艺，环管液相本体聚合+气相流化床共聚，高时空产率',
    category: 'PP',
    feedstock: ['丙烯', '乙烯', '催化剂'],
    products: ['聚丙烯'],
    byproducts: ['未反应单体'],
    processSteps: [
      '环管液相本体聚合',
      '气相流化床共聚',
      '闪蒸脱气',
      '汽蒸钝化',
      '干燥造粒'
    ],
    processType: 'Spheripol',
    temperature: '60-80℃',
    pressure: '1-4 MPa',
    catalyst: '第四代Z-N催化剂',
    advantages: ['技术成熟', '产品切换快', '应用最广', '抗冲共聚能力强'],
    challenges: ['催化剂成本', '产品高端化不足'],
    applications: ['汽车零部件', '家电外壳', 'BOPP(双向拉伸聚丙烯)薄膜', 'PP-R(无规共聚聚丙烯)管材']
  },
  {
    id: 'pp-unipol',
    name: '聚丙烯(PP)Unipol工艺',
    description: '气相流化床反应器，流程最简单，CONSISTA催化剂',
    category: 'PP',
    feedstock: ['丙烯', '乙烯', '催化剂'],
    products: ['聚丙烯'],
    byproducts: ['未反应单体'],
    processSteps: [
      '气相流化床聚合',
      '均聚粉料生成',
      '气相共聚',
      '脱气干燥',
      '造粒包装'
    ],
    processType: 'Unipol',
    temperature: '60-80℃',
    pressure: '1-3 MPa',
    catalyst: 'CONSISTA催化剂',
    advantages: ['流程简单', '投资少', '操作弹性大'],
    challenges: ['产品范围较窄', '抗冲共聚能力有限'],
    applications: ['注塑制品', '薄膜', '纤维']
  },
  {
    id: 'pp-metallocene',
    name: '茂金属聚丙烯(PP)',
    description: '茂金属催化剂制备PP，窄分子量分布，优异光学性能，国产化率不足10%',
    category: 'PP',
    feedstock: ['丙烯', '茂金属催化剂'],
    products: ['茂金属聚丙烯'],
    byproducts: ['未反应丙烯'],
    processSteps: [
      '茂金属催化剂制备',
      '丙烯聚合',
      '产物分离',
      '造粒包装'
    ],
    processType: '茂金属催化',
    temperature: '60-80℃',
    pressure: '1-4 MPa',
    catalyst: '茂金属催化剂',
    advantages: ['分子量分布窄', '光学性能优异', '力学性能好'],
    challenges: ['催化剂成本高', '国产化率低', '技术壁垒高'],
    applications: ['医用透明料', '高端包装', '锂电隔膜料']
  },
  {
    id: 'pvc-ethylene',
    name: '聚氯乙烯(PVC)乙烯法（平衡氧氯化）',
    description: '全球最先进的氯乙烯单体(VCM)生产方法，乙烯直接氯化制二氯乙烷(EDC)，EDC裂解制VCM，氧氯化消耗副产HCl实现氯元素平衡利用，再经VCM悬浮聚合制聚氯乙烯',
    category: 'PVC',
    feedstock: ['乙烯', '氯气', '氧气'],
    feedstockEntry: {
      '乙烯': [0],
      '氯气': [0],
      '氧气': [3],
    },
    products: ['聚氯乙烯'],
    byproducts: ['水', '未反应VCM(氯乙烯)'],
    processSteps: [
      '乙烯直接氯化制二氯乙烷(EDC)',
      '二氯乙烷(EDC)精制',
      'EDC热裂解制氯乙烯(VCM)',
      '氧氯化反应(消耗副产HCl)',
      '氯乙烯(VCM)精制',
      '悬浮聚合',
      '汽提脱氯乙烯(VCM)',
      '干燥包装'
    ],
    processType: '乙烯法',
    temperature: '50-70℃(聚合)',
    pressure: '0.6-1.2 MPa(聚合)',
    catalyst: '氯化铜CuCl₂(氧氯化)',
    keyParameters: [
      '直接氯化: CH₂=CH₂ + Cl₂ → ClCH₂CH₂Cl(EDC二氯乙烷)，90~120℃液相触媒',
      '氧氯化: 2CH₂=CH₂ + 4HCl + O₂ → 2ClCH₂CH₂Cl + 2H₂O，CuCl₂触媒，200~230℃',
      'EDC裂解: ClCH₂CH₂Cl → CH₂=CHCl(VCM氯乙烯) + HCl，500~550℃',
      '悬浮聚合: n CH₂=CHCl → [CH₂—CHCl]n(聚氯乙烯)，引发剂，50~70℃、0.6~1.2 MPa',
    ],
    advantages: ['氯元素完全平衡', '氯乙烯单体(VCM)纯度高', '环保性好', '技术先进'],
    challenges: ['投资成本高', '受油价影响', '工艺复杂'],
    applications: ['管材管件', '型材门窗', '薄膜', '电线电缆']
  },
  {
    id: 'pvc-calcium-carbide',
    name: '聚氯乙烯(PVC)电石乙炔法',
    description: '煤化工路线，电石(碳化钙)水解制乙炔，乙炔与氯化氢(HCl)合成氯乙烯单体(VCM)后悬浮聚合，国内占比约80%，无汞催化剂技术突破',
    category: 'PVC',
    feedstock: ['电石', '氯化氢', '水'],
    feedstockEntry: {
      '电石': [1],
      '水': [1],
      '氯化氢': [3],
    },
    products: ['聚氯乙烯'],
    byproducts: ['电石渣(氢氧化钙)', '未反应VCM(氯乙烯)'],
    processSteps: [
      '电石制备(见电石工业路线)',
      '乙炔发生(电石水解)',
      '乙炔净化(脱硫脱磷)',
      '氯乙烯合成',
      '氯乙烯(VCM)精制',
      '悬浮聚合',
      '汽提脱氯乙烯(VCM)',
      '干燥包装'
    ],
    processType: '电石乙炔法',
    temperature: '150-180℃(合成)',
    pressure: '0.6-1.2 MPa(聚合)',
    catalyst: '金基催化剂(无汞)',
    keyParameters: [
      '电石制备: CaO + 3C → CaC₂ + CO↑，矿热电炉1800~2300℃(见电石工业路线)',
      '乙炔发生: CaC₂ + 2H₂O → CH≡CH(乙炔)↑ + Ca(OH)₂↓，湿式发生器，放热反应',
      '加成合成: CH≡CH + HCl → CH₂=CHCl(VCM氯乙烯)，汞/金基触媒，100~180℃',
      '悬浮聚合: n CH₂=CHCl → [CH₂—CHCl]n(聚氯乙烯)，引发剂，50~70℃、0.6~1.2 MPa',
    ],
    advantages: ['原料来源丰富', '国内成本优势', '不受油价影响', '无汞催化剂突破'],
    challenges: ['电石渣处理', '能耗较高', '传统汞污染'],
    applications: ['管材', '型材', '板材', '人造革']
  },
  {
    id: 'pet-pta-continuous',
    name: '聚酯(PET)PTA法连续工艺',
    description: '主流PET生产工艺，PTA与EG酯化后连续缩聚，适合大规模生产，产品质量稳定',
    category: 'PET',
    feedstock: ['PTA(精对苯二甲酸)', 'EG(乙二醇)'],
    products: ['PET切片'],
    byproducts: ['水', 'EG回收'],
    processSteps: [
      'PTA浆化',
      '第一酯化釜',
      '第二酯化釜',
      '预缩聚釜',
      '终缩聚釜',
      '铸带切粒',
      '固相缩聚(可选)',
      '冷却包装'
    ],
    processType: 'PTA法连续',
    temperature: '250-290℃',
    pressure: '常压→高真空',
    catalyst: '锑系(Sb₂O₃)',
    advantages: ['产品质量稳定', '能耗低', '适合大规模生产', '产品一致性好'],
    challenges: ['牌号切换慢', '投资大', '灵活性较差'],
    applications: ['涤纶纤维', '饮料瓶', '食品包装', '薄膜']
  },
  {
    id: 'pet-pta-batch',
    name: '聚酯(PET)PTA法间歇工艺',
    description: '适合小规模生产，产品切换灵活，主要用于工程塑料和特种PET',
    category: 'PET',
    feedstock: ['PTA(精对苯二甲酸)', 'EG(乙二醇)'],
    products: ['PET切片'],
    byproducts: ['水', 'EG回收'],
    processSteps: [
      'PTA浆化',
      '酯化反应',
      '预缩聚',
      '终缩聚',
      '出料切粒',
      '固相缩聚(可选)',
      '冷却包装'
    ],
    processType: 'PTA法间歇',
    temperature: '250-290℃',
    pressure: '常压→高真空',
    catalyst: '锑系/钛系',
    advantages: ['产品切换灵活', '适合小规模', '投资较小', '适合特种PET'],
    challenges: ['能耗较高', '产品一致性一般', '生产效率低'],
    applications: ['工程塑料', '特种PET', '工业丝']
  },
  {
    id: 'ps-gpps',
    name: '通用聚苯乙烯(GPPS)本体聚合',
    description: '通用聚苯乙烯生产，透明、刚性、光泽度高，用于日用品和包装',
    category: 'PS',
    feedstock: ['苯乙烯', '乙苯(溶剂)', '引发剂'],
    products: ['GPPS(通用聚苯乙烯,透苯)'],
    byproducts: ['未反应苯乙烯', '乙苯'],
    processSteps: [
      '原料预热',
      '预聚反应',
      '串联聚合反应器',
      '逐步升温聚合',
      '脱挥器闪蒸',
      '挤出造粒',
      '冷却包装'
    ],
    processType: '本体聚合',
    temperature: '90-180℃',
    pressure: '常压',
    catalyst: '过氧化苯甲酸叔丁酯(TBPB)引发剂',
    advantages: ['透明度高', '刚性好', '易加工', '尺寸稳定'],
    challenges: ['质脆易裂', '耐热性差', '易燃'],
    applications: ['日用品', '包装', '文具', '透明制品']
  },
  {
    id: 'ps-hips',
    name: '高抗冲聚苯乙烯(HIPS)本体聚合',
    description: '高抗冲聚苯乙烯，含5-9%聚丁二烯橡胶改性，乳白色，用于家电外壳',
    category: 'PS',
    feedstock: ['苯乙烯', '聚丁二烯橡胶', '引发剂'],
    products: ['HIPS(高抗冲聚苯乙烯,改苯)'],
    byproducts: ['未反应苯乙烯'],
    processSteps: [
      '橡胶溶解',
      '预聚反应',
      '相翻转控制',
      '本体接枝聚合',
      '脱挥',
      '挤出造粒',
      '冷却包装'
    ],
    processType: '本体聚合',
    temperature: '90-180℃',
    pressure: '常压',
    catalyst: 'TBPB引发剂',
    advantages: ['抗冲击性好', '加工性好', '成本较低', '应用广泛'],
    challenges: ['透明性差', '耐热性有限', '橡胶粒径控制'],
    applications: ['家电外壳', '电脑外壳', '玩具', '办公用品']
  },
  {
    id: 'ps-eps',
    name: '可发性聚苯乙烯(EPS)悬浮聚合',
    description: '可发性聚苯乙烯，含发泡剂，用于建筑保温和缓冲包装',
    category: 'PS',
    feedstock: ['苯乙烯', '发泡剂(戊烷/丁烷)', '分散剂', '引发剂'],
    products: ['EPS珠粒'],
    byproducts: ['未反应苯乙烯'],
    processSteps: [
      '原料混合',
      '悬浮聚合',
      '浸渍发泡剂',
      '洗涤干燥',
      '筛分包装',
      '预发泡(使用时)',
      '熟化',
      '成型'
    ],
    processType: '悬浮聚合',
    temperature: '85℃(聚合)',
    pressure: '常压',
    catalyst: '过氧化物引发剂',
    advantages: ['隔热隔音', '质轻', '缓冲性好', '成本低'],
    challenges: ['易燃', '环保压力', '发泡剂控制'],
    applications: ['建材保温板', '缓冲包装', '一次性餐具']
  },
  {
    id: 'abs-emulsion',
    name: 'ABS(丙烯腈-丁二烯-苯乙烯)树脂乳液接枝掺混法',
    description: '传统主流工艺，丁二烯乳液聚合制PB乳胶，苯乙烯和丙烯腈接枝聚合，产品灵活性最高',
    category: 'ABS',
    feedstock: ['丁二烯', '苯乙烯', '丙烯腈'],
    products: ['ABS树脂'],
    byproducts: ['废水', '未反应单体'],
    processSteps: [
      '丁二烯乳液聚合',
      '聚丁二烯(PB)乳胶制备',
      '乳液接枝聚合',
      '凝聚洗涤',
      '干燥',
      '苯乙烯-丙烯腈(SAN)共聚物制备',
      '熔融掺混',
      '挤出造粒'
    ],
    processType: '乳液接枝掺混',
    temperature: '50-80℃',
    pressure: '常压',
    catalyst: '过硫酸盐引发剂',
    advantages: ['产品灵活性最高', '橡胶含量可达30%', '适合高抗冲产品', '技术成熟'],
    challenges: ['废水多', '流程长', '环保压力大'],
    applications: ['汽车零部件', '家电外壳', '电子电器', '管材']
  },
  {
    id: 'abs-mass',
    name: 'ABS(丙烯腈-丁二烯-苯乙烯)树脂连续本体法',
    description: '发展方向，顺丁橡胶溶于单体后本体接枝聚合，流程短、能耗低、环保',
    category: 'ABS',
    feedstock: ['顺丁橡胶', '苯乙烯', '丙烯腈'],
    products: ['ABS树脂'],
    byproducts: ['未反应单体'],
    processSteps: [
      '橡胶溶解',
      '预聚反应',
      '相翻转',
      '本体接枝聚合',
      '脱挥',
      '挤出造粒',
      '冷却包装'
    ],
    processType: '连续本体',
    temperature: '80-150℃',
    pressure: '常压',
    catalyst: '有机过氧化物',
    advantages: ['流程短', '能耗低', '废水极少', '投资低'],
    challenges: ['橡胶含量≤20%', '高抗冲产品有局限', '相翻转控制难'],
    applications: ['家电外壳', '电子电器', '汽车内饰']
  }
];

